<template>
  <div style="margin-top: -20px; margin-bottom: -20px;"
       class="min-h-screen  bg-gradient-to-br from-slate-900 via-slate-950 to-slate-900 text-slate-100 flex flex-col relative overflow-hidden">
    <div class="absolute inset-0 overflow-hidden pointer-events-none">
      <div class="absolute -top-40 -right-40 w-80 h-80 bg-amber-400/10 rounded-full blur-3xl"></div>
      <div class="absolute -bottom-40 -left-40 w-80 h-80 bg-pink-400/10 rounded-full blur-3xl"></div>
      <div
          class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-amber-300/5 rounded-full blur-3xl"></div>
    </div>

    <div class="fixed left-6 top-1/2 -translate-y-1/2 z-50">
      <div class="flex flex-col items-center gap-4">
        <button
            @click="navOpen = !navOpen"
            class="group relative w-12 h-12 rounded-2xl bg-slate-900/80 backdrop-blur-xl border border-amber-400/30
                 shadow-2xl shadow-amber-500/20 flex items-center justify-center transition-all duration-300
                 hover:border-amber-400/60 hover:shadow-amber-500/30 hover:scale-105"
        >
          <div
              class="absolute inset-0 rounded-2xl bg-gradient-to-r from-amber-400/20 to-pink-400/20 opacity-0 group-hover:opacity-100 transition-opacity"></div>
          <svg class="w-5 h-5 text-amber-300 relative z-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-width="2" d="M4 7h16M4 12h10M4 17h16"/>
          </svg>
        </button>

        <!-- Navigation Panel -->
        <transition
            enter-active-class="transition-all duration-300 ease-out"
            leave-active-class="transition-all duration-200 ease-in"
            enter-class="opacity-0 transform -translate-x-4"
            enter-to-class="opacity-100 transform translate-x-0"
            leave-class="opacity-100 transform translate-x-0"
            leave-to-class="opacity-0 transform -translate-x-4"
        >
          <div
              v-if="navOpen"
              class="flex flex-col gap-3 px-3 py-4 rounded-3xl bg-slate-900/80 backdrop-blur-xl border border-white/10
                   shadow-2xl shadow-amber-500/20"
          >
            <button
                @click="setTab('pos')"
                class="group relative w-12 h-12 rounded-2xl flex flex-col items-center justify-center text-[10px] gap-1
                     transition-all duration-300"
                :class="activeTab === 'pos'
                ? 'bg-gradient-to-b from-amber-400 via-amber-500 to-amber-300 text-slate-950 shadow-2xl shadow-amber-500/40'
                : 'bg-slate-800/50 text-slate-100 hover:bg-slate-700/80 border border-white/5 hover:border-amber-400/20'"
            >
              <div v-if="activeTab === 'pos'"
                   class="absolute inset-0 rounded-2xl bg-gradient-to-b from-amber-400/20 to-amber-300/20"></div>
              <svg class="w-4 h-4 relative z-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M3 3h18M5 7h14v10a2 2 0 01-2 2H7a2 2 0 01-2-2V7z"/>
              </svg>
              <span class="relative z-10 font-semibold">سفارش</span>
            </button>

            <button
                @click="setTab('orders')"
                class="group relative w-12 h-12 rounded-2xl flex flex-col items-center justify-center text-[10px] gap-1
                     transition-all duration-300"
                :class="activeTab === 'orders'
                ? 'bg-gradient-to-b from-amber-400 via-amber-500 to-amber-300 text-slate-950 shadow-2xl shadow-amber-500/40'
                : 'bg-slate-800/50 text-slate-100 hover:bg-slate-700/80 border border-white/5 hover:border-amber-400/20'"
            >
              <div v-if="activeTab === 'orders'"
                   class="absolute inset-0 rounded-2xl bg-gradient-to-b from-amber-400/20 tto-amber-300/20"></div>
              <svg class="w-4 h-4 relative z-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M7 8h10M7 12h6M5 5h14a2 2 0 012 2v10a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2z"/>
              </svg>
              <span class="relative z-10 font-semibold">سفارشات</span>
            </button>

            <button
                @click="setTab('overview')"
                class="group relative w-12 h-12 rounded-2xl flex flex-col items-center justify-center text-[10px] gap-1
                     transition-all duration-300"
                :class="activeTab === 'overview'
                ? 'bg-gradient-to-b from-amber-400 via-amber-500 to-amber-300 text-slate-950 shadow-2xl shadow-amber-500/40'
                : 'bg-slate-800/50 text-slate-100 hover:bg-slate-700/80 border border-white/5 hover:border-amber-400/20'"
            >
              <div v-if="activeTab === 'overview'"
                   class="absolute inset-0 rounded-2xl bg-gradient-to-b from-amber-400/20 to-amber-300/20"></div>
              <svg class="w-4 h-4 relative z-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M4 19h4V9H4v10zm6 0h4V5h-4v14zm6 0h4V13h-4v6z"/>
              </svg>
              <span class="relative z-10 font-semibold">گزارش</span>
            </button>
            <button
                @click="logout"
                class="group relative w-12 h-12 rounded-2xl flex flex-col items-center justify-center text-[10px] gap-1
                     transition-all duration-300"
            >
              <div v-if="activeTab === 'overview'"
                   class="absolute inset-0 rounded-2xl bg-gradient-to-b from-amber-400/20 to-amber-300/20"></div>
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4M10 17l5-5m0 0l-5-5m5 5H3"/>
              </svg>
              <span class="relative z-10 font-semibold">خروج</span>
            </button>
          </div>
        </transition>
      </div>
    </div>

    <div class="relative border-b border-white/10 bg-slate-900/80 backdrop-blur-2xl">
      <div class="absolute inset-0 bg-gradient-to-r from-amber-500/5 via-pink-500/5 to-transparent"></div>

      <div
          class="relative mx-auto max-w-7xl py-4 px-6 flex flex-col md:flex-row md:items-center md:justify-between gap-4">

        <div class="flex items-center gap-4 pt-2">
          <div class="relative">
            <div class="w-14 h-14 rounded-2xl bg-slate-900/80 backdrop-blur-xl border border-amber-400/30
                   flex items-center justify-center shadow-2xl shadow-amber-500/20 overflow-hidden">
              <img
                  v-if="user.profile_picture"
                  :src="img_source(user.profile_picture)"
                  :alt="user.username"
                  class="w-full h-full object-cover"
              >
              <div v-else
                   class="w-full h-full bg-gradient-to-br from-amber-500 to-pink-600 flex items-center justify-center">
                <span class="text-lg font-black text-white">👤</span>
              </div>
            </div>

            <!-- Online Badge -->
            <div class="absolute -bottom-1 -right-1 w-5 h-5 bg-emerald-500 rounded-full border-2 border-slate-900
                   flex items-center justify-center shadow-lg shadow-emerald-500/50">
              <div class="w-1.5 h-1.5 bg-white rounded-full animate-pulse"></div>
            </div>

            <!-- Glow Effect -->
            <div class="absolute -inset-2 rounded-2xl bg-amber-400/10 blur-md opacity-60"></div>
          </div>

          <div class="text-right">
            <h1 class="text-xl font-bold text-slate-50 drop-shadow-lg flex items-center gap-2">
              فروشگاه
              <span class="text-amber-300">EXUNI</span>
            </h1>
            <p class="text-sm text-slate-300/80 mt-1 font-light">
              {{ user.username || 'کاربر' }} - ادمین {{ title }}
              <span
                  class="text-xs px-2 py-1 bg-emerald-500/20 text-emerald-300 rounded-lg border border-emerald-400/30">
                آنلاین
              </span>

            </p>
          </div>
        </div>

        <div class="flex flex-wrap items-center gap-3">
          <!--
          <div
              class="inline-flex items-center px-4 py-2.5 rounded-2xl border backdrop-blur-xl text-sm font-medium
               transition-all duration-200 hover:scale-105 bg-gradient-to-r from-emerald-500/15 to-emerald-600/10
               text-emerald-200 border-emerald-400/30 group cursor-pointer"
              @click="activeTab = 'overview'"
          >
            <div class="flex items-center gap-2">
              <div class="relative">
                <span class="w-2 h-2 rounded-full bg-emerald-400 animate-pulse"></span>
                <span class="absolute inset-0 rounded-full bg-emerald-400 animate-ping opacity-75"></span>
              </div>
              <span class="font-bold">فروش امروز:</span>
              <span class=" text-emerald-100">{{ overview.today_total | toMoney(0) }}</span>
            </div>
          </div>
          <div
              class="inline-flex items-center px-4 py-2.5 rounded-2xl border backdrop-blur-xl text-sm font-medium
               transition-all duration-200 hover:scale-105 bg-gradient-to-r from-indigo-500/15 to-indigo-600/10
               text-indigo-200 border-indigo-400/30 group cursor-pointer"
              @click="activeTab = 'orders'"
          >
            <div class="flex items-center gap-2">
              <svg class="w-4 h-4 text-indigo-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"/>
              </svg>
              <span class="font-bold">سفارش‌ها:</span>
              <span class=" text-indigo-100">{{ overview.today_orders }}</span>
            </div>
          </div>
              -->
        </div>
      </div>
    </div>
    <div class="relative w-full px-6 pt-6 pb-8 flex-1 flex flex-col">
      <transition
          enter-active-class="transition-all duration-300 ease-out"
          leave-active-class="transition-all duration-200 ease-in"
          enter-class="opacity-0 transform translate-y-2"
          enter-to-class="opacity-100 transform translate-y-0"
          leave-class="opacity-100 transform translate-y-0"
          leave-to-class="opacity-0 transform translate-y-2"
      >
        <div
            v-if="notice"
            class="mb-4 rounded-2xl border border-emerald-400/40 bg-emerald-500/10 backdrop-blur-xl px-5 py-4
                 text-emerald-100 text-sm flex items-center gap-3 shadow-2xl shadow-emerald-500/20"
        >
          <div class="w-2 h-2 rounded-full bg-emerald-400 animate-pulse"></div>
          <svg class="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
          </svg>
          <span class="font-medium">{{ notice }}</span>
        </div>
      </transition>

      <div class="flex-1 flex flex-col space-y-1 w-full max-w-none ">
        <div v-show="activeTab === 'pos'"
             class="px-4 py-2 ml-10 w-full rounded-3xl border border-white/10 bg-gradient-to-br from-slate-900/80 to-slate-800/70 backdrop-blur-2xl shadow-2xl shadow-black/40 flex flex-col overflow-hidden h-full ">

          <div class="flex-1 min-h-0 space-y-1">
            <div class="relative">

              <div class="relative group">
                <div
                    class="absolute inset-0 rounded-2xl bg-gradient-to-r from-amber-400/30 to-pink-400/30 blur-lg opacity-0 group-focus-within:opacity-100 transition-all duration-500"></div>
                <div class="relative flex items-center gap-3 rounded-md border-2 border-amber-400/40 bg-slate-900/80 backdrop-blur-xl
                   px-4 py-4 transition-all duration-300 group-focus-within:border-amber-400/80
                   group-focus-within:shadow-2xl group-focus-within:shadow-amber-500/30">
                  <svg class="w-5 h-5 text-amber-300 flex-shrink-0" fill="none" stroke="currentColor"
                       viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M21 21l-4.35-4.35M10.5 6a4.5 4.5 0 100 9 4.5 4.5 0 000-9z"/>
                  </svg>
                  <input
                      ref="searchInput"
                      v-model="searchQuery"
                      type="text"
                      class="w-32 flex-1 bg-transparent border-none rounded-md focus:ring-0 focus:outline-none text-xs text-slate-50
                      placeholder-slate-400/80 text-right "
                      placeholder="نام محصول، SKU یا کد ۱۶ رقمی..."
                  />
                  <div class="flex-shrink-0">
                    <button
                        v-if="searchQuery"
                        @click="clearSearch"
                        class="px-3 py-1.5 text-xs rounded-xl bg-slate-800 text-slate-200 hover:bg-slate-700
                     transition-all duration-200 hover:scale-105"
                    >
                      پاک کردن
                    </button>
                  </div>
                </div>

                <transition
                    enter-active-class="transition-all duration-300 ease-out"
                    leave-active-class="transition-all duration-200 ease-in"
                    enter-class="opacity-0 scale-95"
                    enter-to-class="opacity-100 scale-100"
                    leave-class="opacity-100 scale-100"
                    leave-to-class="opacity-0 scale-95"
                >
                  <div
                      v-if="searchQuery && (searchLoading || searchResults.length)"
                      class="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-xl p-4"
                  >
                    <div
                        class="w-full max-w-4xl rounded-3xl border-2 border-amber-400/30 bg-slate-950/95
               shadow-2xl shadow-black/60 max-h-[85vh] overflow-hidden"
                    >

                      <div
                          v-if="searchLoading"
                          class="px-6 py-8 text-sm text-slate-300 flex items-center justify-center gap-3"
                      >
                        <svg class="w-6 h-6 animate-spin text-amber-400" fill="none" stroke="currentColor"
                             viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
                        </svg>
                        <span class="font-medium">در حال جستجو در پایگاه داده...</span>
                      </div>

                      <template v-else>
                        <div class="border-b border-white/10 p-4 bg-slate-900/50 flex flex-col gap-3">
                          <div class="flex items-center justify-between gap-3">
                            <div class="text-sm text-slate-300">
                              <span class="text-amber-300 font-bold">{{ filteredSearchResults.length }}</span>
                              نتیجه از
                              <span class="text-slate-100 font-bold">{{ searchResults.length }}</span>
                            </div>

                            <button
                                @click="closeSearchPopup"
                                class="text-xs text-slate-400 hover:text-slate-100"
                            >
                              بستن ✕
                            </button>
                          </div>

                          <div class="relative">
                            <input
                                ref="popupNameSearchInput"
                                v-model="popupNameSearch"
                                type="text"
                                class="w-full px-4 py-3 rounded-2xl bg-slate-900/80 border border-amber-400/25
               text-slate-50 placeholder-slate-500 text-right text-sm
               focus:outline-none focus:ring-2 focus:ring-amber-400/25 focus:border-amber-400/60"
                                placeholder="فیلتر سریع بر اساس نام محصول..."
                                @keydown.stop
                                @keyup.stop
                                @keypress.stop
                            />

                            <button
                                v-if="popupNameSearch"
                                @click="popupNameSearch = ''"
                                class="absolute left-3 top-1/2 -translate-y-1/2 text-xs text-slate-400 hover:text-slate-100"
                            >
                              پاک کردن
                            </button>
                          </div>
                        </div>
                        <div class="divide-y divide-white/5 max-h-[73vh] overflow-y-auto custom-scrollbar">
                          <button
                              v-for="(p, idx) in filteredSearchResults"
                              :key="p.id"
                              :ref="'searchItem_' + idx"
                              @click="selectSearchProduct(p)"
                              @mouseenter="selectedSearchIndex = idx"
                              :disabled="!p.inventory_count || Number(p.inventory_count) <= 0"
                              class="w-full text-right px-6 py-4 flex gap-4 hover:bg-slate-800/80 transition-all duration-200
             group relative overflow-hidden search-result-item"
                              :class="[
        (!p.inventory_count || Number(p.inventory_count) <= 0)
          ? 'opacity-60 cursor-not-allowed hover:bg-slate-900/80'
          : '',
        selectedSearchIndex === idx ? 'bg-slate-800/80 border-r-2 border-amber-400' : ''
      ]"
                          >
                                <!-- Background Hover Effect -->
                            <div
                                class="absolute inset-0 bg-gradient-to-r from-amber-500/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

                            <!-- image -->
                            <div class="flex-shrink-0 relative z-10">
                              <div class="w-16 h-16 rounded-2xl bg-slate-800 overflow-hidden border-2 border-white/10
                          group-hover:border-amber-400/50 transition-all duration-300 group-hover:scale-105">
                                <img
                                    v-if="p.image"
                                    :src="img_source(p.image)"
                                    alt="img"
                                    class="w-full h-full object-cover"
                                />
                                <div v-else
                                     class="w-full h-full bg-gradient-to-br from-slate-700 to-slate-600 flex items-center justify-center">
                                  <svg class="w-6 h-6 text-slate-400" fill="none" stroke="currentColor"
                                       viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                          d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"/>
                                  </svg>
                                </div>
                              </div>
                            </div>

                            <div class="flex-1 flex flex-col gap-2 min-w-0 relative z-10">
                              <div class="flex items-center justify-between gap-4">
                              <span class="text-slate-50 truncate leading-tight text-[10px]">
                                <span class="text-base font-bold text-slate-50 truncate leading-tight text-[8px]"
                                      v-if="p.variation_of_name">
                                  {{ p.variation_of_name }} :
                                </span>
                                {{ p.name }}
                              </span>
                                <span
                                    class="text-lg font-bold text-emerald-300 whitespace-nowrap bg-emerald-500/10 px-3 py-1 rounded-xl">

                                  <div
                                      v-if="p.regular_price && p.unit_price && p.unit_price < p.regular_price"
                                      class="absolute right-2 top-1 inline-flex items-center py-[2px] rounded-full bg-emerald-500/20 text-emerald-200 text-[10px] font-bold"
                                  >
                                    {{ lineDiscountPercent(p) }}٪
                                  </div>
                                  <div class="flex flex-col items-center text-[10px] leading-tight text-right">
                                    <span class="text-slate-400">
                                      قیمت :
                                      <span v-if="p.regular_price" class=" text-slate-400 line-through text-[12px]">  {{
                                          p.regular_price | toMoney(0)
                                        }}  </span>
                                      <span v-else class="text-slate-500">
                                        {{ p.unit_price | toMoney(0) }}
                                      </span>
                                    </span>
                                    <span class="mt-1 text-slate-400">
                                      قیمت اکسونی :
                                      <span class="text-[12px] font-semibold text-slate-100 text-[12px]">
                                        {{ p.price | toMoney(0) }}
                                      </span>
                                    </span>
                                  </div>

                              </span>
                              </div>

                              <div class="flex items-center justify-between text-sm text-slate-400">
                                <div class="flex items-center gap-4">
                                  <span class="bg-slate-800/50 px-2 py-1 rounded-lg">
                                    کد: {{ p.sixteen_digit_code || '---' }}
                                  </span>
                                  <span
                                      style="max-width: 100px"
                                      class="flex items-center gap-1 px-2 py-1 rounded-lg"
                                      :class="(p.inventory_count && Number(p.inventory_count) > 0)
                                                  ? 'bg-slate-800/50'
                                                  : 'bg-rose-950/60 text-rose-300 border border-rose-500/40'"
                                  >
                                    <span
                                        class="w-2 h-2 rounded-full"
                                        :class="(p.inventory_count && Number(p.inventory_count) > 0)
                                                  ? 'bg-emerald-400'
                                                  : 'bg-rose-400'"
                                    ></span>
                                    <template v-if="p.inventory_count && Number(p.inventory_count) > 0">
                                      موجودی: {{ p.inventory_count }}
                                    </template>
                                    <template v-else>
                                      ناموجود
                                    </template>
                                  </span>
                                </div>

                                <div class="flex items-center gap-3">
                                  <span class="bg-slate-800/50 px-2 py-1 rounded-lg">راهرو: {{ p.aisle || '-' }}</span>
                                  <span class="bg-slate-800/50 px-2 py-1 rounded-lg">قفسه: {{
                                      p.shelf_number || '-'
                                    }}</span>
                                </div>
                              </div>
                            </div>

                            <div class="flex-shrink-0 relative z-10"
                                 v-if="p.inventory_count && Number(p.inventory_count) > 0">
                              <div class="w-8 h-8 rounded-full bg-gradient-to-r from-amber-500 to-amber-600 flex items-center justify-center
                          opacity-0 group-hover:opacity-100 transition-all duration-300 transform group-hover:scale-110">
                                <svg class="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M12 6v6m0 0v6m0-6h6m-6 0H6"/>
                                </svg>
                              </div>
                            </div>
                          </button>
                        </div>

                        <!-- no results -->
                        <div
                            v-if="!filteredSearchResults.length"
                            class="px-6 py-12 text-center"
                        >
                          <svg class="w-16 h-16 text-slate-600 mx-auto mb-4" fill="none" stroke="currentColor"
                               viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1"
                                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
                          </svg>
                          <p class="text-slate-400 font-medium">نتیجه‌ای یافت نشد</p>
                          <p class="text-slate-500 text-sm mt-2">لطفاً عبارت جستجو را تغییر دهید</p>
                        </div>
                      </template>

                    </div>
                  </div>
                </transition>
              </div>
            </div>

            <div class="flex items-center justify-between gap-4">
              <!-- Customer Info -->
              <div class="flex-1 rounded-md border-2 border-amber-400/20 bg-slate-900/80 backdrop-blur-xl px-2 py-2">
                <div class="grid grid-cols-3 gap-2">
                  <input
                      v-model="customer.first_name"
                      type="text"
                      class="w-full px-2 py-1.5 border border-white/10 rounded-md text-xs bg-slate-900/60
                         text-slate-100 placeholder-slate-400 backdrop-blur-xl focus:border-amber-400/60
                         focus:ring-1 focus:ring-amber-400/30 transition-all duration-150"
                      placeholder="نام"
                  />
                  <input
                      v-model="customer.last_name"
                      type="text"
                      class="w-full px-2 py-1.5 border border-white/10 rounded-md text-xs bg-slate-900/60
                         text-slate-100 placeholder-slate-400 backdrop-blur-xl focus:border-amber-400/60
                         focus:ring-1 focus:ring-amber-400/30 transition-all duration-150"
                      placeholder="نام خانوادگی"
                  />
                  <input
                      v-model="customer.phone_number"
                      type="tel"
                      class="w-full px-2 py-1.5 border border-white/10 rounded-md text-xs bg-slate-900/60
                         text-slate-100 placeholder-slate-400 backdrop-blur-xl focus:border-amber-400/60
                         focus:ring-1 focus:ring-amber-400/30 transition-all duration-150"
                      placeholder="شماره موبایل"
                  />
                </div>
              </div>

              <div class="flex-shrink-0">
                <div class="text-right">
                  <div class="text-xs font-medium text-slate-300">مبلغ فاکتور</div>
                  <div class="text-md font-black text-amber-300 mt-0.5">{{ grandTotal | toMoney(0) }}</div>
                </div>
              </div>

              <div class="flex-shrink-0">
                <button
                    style="max-width: 150px"
                    @click="submitOrder"
                    :disabled="!cartItems.length || loading.submit"
                    class="px-4 py-2 rounded-md bg-gradient-to-r from-amber-400 via-amber-500 to-pink-500
                    hover:from-amber-300 hover:via-amber-400 hover:to-pink-400 text-slate-950 text-xs
                    disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-150
                     flex items-center justify-center gap-1.5"
                >
                  <svg
                      v-if="loading.submit"
                      class="w-3.5 h-3.5 animate-spin"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                  >
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
                  </svg>
                  <span>{{ loading.submit ? 'در حال ثبت...' : '📦 ثبت و صدور فاکتور' }}</span>
                </button>
              </div>
            </div>
            <div
                class="rounded-3xl border-2 border-amber-400/20 bg-gradient-to-br from-slate-900/80 to-slate-800/70 backdrop-blur-2xl shadow-2xl shadow-black/40 flex flex-col overflow-hidden flex-1 min-h-0">
              <div class="border-b border-amber-400/20 bg-gradient-to-r from-slate-900 to-slate-800 px-6 py-4">
                <div class="flex items-center justify-between">
                  <div class="flex items-center gap-4">
                    <button
                        style="max-width: 150px"
                        v-if="cartItems.length"
                        @click="clearCart"
                        class="px-1 py-2 rounded-md bg-rose-500/20 text-rose-200 border border-rose-400/50
                     hover:bg-rose-500/30 text-sm transition-all duration-200 hover:scale-105 flex items-center gap-2"
                    >
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                              d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                      </svg>
                      <span class="text-xs">خالی کردن سبد</span>
                    </button>
                    <button
                        style="max-width: 150px"
                        @click="openDiscountModal"
                        class="px-1 py-2 rounded-md bg-pink-500/20 text-pink-100 border-pink-400/60 hover:bg-pink-500/30
                     hover:bg-pink-500/30 text-sm transition-all duration-200 hover:scale-105 flex items-center gap-2"
                    >
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                              d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                      </svg>
                      <span class="text-xs">تخفیف کلی</span>
                    </button>
                    <button
                        style="max-width: 150px"
                        @click="openWholesaleModal"
                        class="px-1 py-2 rounded-md bg-amber-500/20 text-amber-100 border-amber-400/60 hover:bg-amber-500/30
                          hover:bg-amber-500/30 text-sm transition-all duration-200 hover:scale-105 flex items-center gap-2"
                    >
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                              d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"/>

                      </svg>
                      <span class="text-xs">تنظیم سود عمده</span>
                    </button>
                  </div>
                </div>
              </div>

              <!-- Table Content -->
              <div class="flex-1 overflow-auto max-h-[420px] custom-scrollbar">
                <table class="w-full text-sm">
                  <thead
                      class="bg-gradient-to-r from-slate-900 to-slate-800 border-b border-amber-400/20 text-slate-200 sticky top-0 z-10">
                  <tr>
                    <th class="px-1 py-2 text-center">کالا</th>
                    <th class="px-1 py-2 text-center">قیمت واحد</th>
                    <th class="px-1 py-2 text-center">تعداد</th>
                    <th class="px-1 py-2 text-center">عمده</th>
                    <th class="px-1 py-2 text-center">تخفیف</th>
                    <th class="px-1 py-2 ">نهایی</th>
                    <th class="px-1 py-2 ">جمع ردیف</th>
                  </tr>
                  </thead>

                  <tbody class="divide-y divide-amber-400/10">
                  <tr
                      v-for="(item, idx) in cartItems"
                      :key="item._key"
                      class="hover:bg-slate-800/50 transition-all duration-200 group border-b border-amber-400/5"
                  >
                    <td class="px-2 py-1 align-top items-center">
                      <div class="flex gap-4 items-start">
                        <div class="flex-shrink-0">
                          <div class="w-12 h-12 rounded-2xl bg-slate-800 overflow-hidden border-2 border-white/10
                               group-hover:border-amber-400/50 transition-all duration-300">
                            <img
                                v-if="item.product.image"
                                :src="img_source(item.product.image)"
                                alt="img"
                                class="w-full h-full object-cover"
                            />
                            <div v-else
                                 class="w-full h-full bg-gradient-to-br from-slate-700 to-slate-600 flex items-center justify-center">
                              <svg class="w-6 h-6 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                      d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"/>
                              </svg>
                            </div>
                          </div>
                        </div>

                        <div class="flex flex-col min-w-0 flex-1">
                    <span class=" text-slate-50 truncate leading-tight  text-[10px]">
                      <span class="text-base font-bold text-slate-50 truncate leading-tight text-[8px]"
                            v-if="item.product.variation_of_name">
                      {{ item.product.variation_of_name }}
                        :
                      </span>

                      {{ item.product.name }}
                    </span>
                          <div class="flex items-center gap-3 mt-2">
                      <span class="text-xs text-slate-400 bg-slate-800/50 px-2 py-1 rounded-lg ">
                        {{ item.product.sixteen_digit_code || '---' }}
                      </span>
                            <span
                                v-if="item.is_wholesale"
                                class="inline-flex items-center px-2 py-1 rounded-full bg-amber-500/20 text-amber-200
                               border border-amber-400/60 text-xs font-bold"
                            >
                        <svg class="w-3 h-3 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"/>
                        </svg>
                        عمده
                      </span>
                          </div>
                        </div>
                      </div>
                    </td>

                    <td class="relative px-1 py-2 align-top">
                      <div
                          v-if="item.regular_price && item.unit_price && item.unit_price < item.regular_price"
                          class="absolute right-2 top-1 inline-flex items-center px-2 py-[2px] rounded-full bg-emerald-500/20 text-emerald-200 text-[10px] font-bold"
                      >
                        {{ lineDiscountPercent(item) }}٪
                      </div>

                      <div class="flex flex-col items-center gap-0.5 text-[10px] leading-tight text-right">
                        <span class="text-slate-400">
                          {{ item.isDomestic ? 'قیمت مصرف کننده' : 'قیمت' }}
                        <span v-if="item.regular_price" class=" text-slate-400 line-through text-[12px]">  {{
                            item.regular_price | toMoney(0)
                          }}  </span>
                          <span v-else class="text-slate-500">
                          {{ item.unit_price | toMoney(0) }}
                        </span>
                        </span>

                        <span class="mt-1 text-slate-400">
                          قیمت اکسونی :
                        <span class="text-[12px] font-semibold text-slate-100 text-[12px]">
                          {{ item.unit_price | toMoney(0) }}
                        </span>
                        </span>
                      </div>
                    </td>

                    <!-- Quantity Column -->
                    <td class="px-1 py-2  align-top">
                      <div class="inline-flex items-center border-2 border-amber-400/30 rounded-2xl overflow-hidden
                           bg-slate-900/80 backdrop-blur-xl transition-all duration-200 hover:border-amber-400/50">
                        <button
                            @click="changeQuantity(idx, item.quantity - 1)"
                            class="px-1.5 py-1 text-slate-300 hover:bg-slate-800 transition-colors text-lg font-bold"
                        >
                          -
                        </button>
                        <input
                            type="number"
                            min="1"
                            :max="item.product && item.product.inventory_count != null ? item.product.inventory_count : null"
                            class="w-20 text-center text-lg bg-slate-950/90 border-x border-amber-400/20 focus:outline-none
                            text-slate-50 focus:bg-slate-900 font-bold"
                            v-model.number="item.quantity"
                            @change="onQuantityInput(idx)"
                        />
                        <button
                            @click="changeQuantity(idx, item.quantity + 1)"
                            class="px-1.5 py-1 text-slate-300 hover:bg-slate-800 transition-colors text-lg font-bold"
                        >
                          +
                        </button>
                        <button
                            @click="removeItem(idx)"
                            class="w-5 h-5 rounded-md bg-rose-500/20 text-rose-200 border-2 border-rose-400/50 mr-2 ml-1
                         hover:bg-rose-500/30 transition-all duration-200 hover:scale-110 flex items-center justify-center"
                        >
                          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                  d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                          </svg>
                        </button>

                      </div>
                    </td>
                    <td class="px-1 py-2  align-top">
                      <div class="flex flex-col items-center gap-3">
                        <button
                            type="button"
                            class="inline-flex items-center gap-2 px-3 py-2 rounded-2xl border border-indigo-400/25 bg-indigo-500/10 text-indigo-200 text-xs hover:bg-indigo-500/15"
                            @click.stop="openItemWholesaleModal(item)"
                        >
                          <div class="flex items-center gap-2">
                            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M3 7h18M6 7v13h12V7M9 20v-6h6v6"/>
                            </svg>
                            <span>{{ itemWholesaleLabel(item) }}</span>
                          </div>

                          <div
                              v-if="item.is_wholesale"
                              class="text-[10px] mt-0.5 opacity-80"
                          >
                            {{ item.unit_price | toMoney(0) }}
                          </div>
                        </button>
                      </div>
                    </td>

                    <td class="px-1 py-2  align-top">
                      <div class="flex flex-col items-center gap-3">
                        <button
                            type="button"
                            class="inline-flex items-center gap-2 px-3 py-2 rounded-2xl border border-indigo-400/25 bg-indigo-500/10 text-indigo-200 text-xs hover:bg-indigo-500/15"
                            @click.stop="openItemDiscountModal(item)"
                        >
                          <span>{{ itemDiscountLabel(item) }}</span>
                          <span v-if="Number(item.line_discount_amount || 0) > 0" class="text-rose-200">
                            ({{ item.line_discount_amount | toMoney(0) }})
                          </span>
                        </button>
                      </div>
                    </td>

                    <td class="px-1 py-2  align-top">
                      <div class="text-lg font-bold text-amber-300">
                        {{ (item.line_total / item.quantity) | toMoney(0) }}
                      </div>
                      <div v-if="item.line_discount_amount > 0" class="text-xs text-slate-400 mt-1 line-through">
                        {{ (item.unit_price)  | toMoney(0) }}
                      </div>
                    </td>
                    <td class="px-1 py-2  align-top">
                      <div class="text-lg font-bold text-amber-300">
                        {{ item.line_total | toMoney(0) }}
                      </div>
                      <div v-if="item.line_discount_amount > 0" class="text-xs text-slate-400 mt-1 line-through">
                        {{ (item.quantity * item.unit_price)  | toMoney(0) }}
                      </div>
                    </td>
                  </tr>

                  <!-- Empty State -->
                  <tr v-if="!cartItems.length">
                    <td colspan="7" class="px-6 py-16 text-center">
                      <div class="flex flex-col items-center gap-4 text-slate-500">
                        <div
                            class="w-20 h-20 rounded-2xl bg-slate-800/50 border-2 border-dashed border-slate-600 flex items-center justify-center">
                          <svg class="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1"
                                  d="M3 3h18M5 7h14v10a2 2 0 01-2 2H7a2 2 0 01-2-2V7z"/>
                          </svg>
                        </div>
                        <div class="text-lg font-medium">سبد خرید خالی است</div>
                        <div class="text-sm">از باکس جستجوی بالا برای افزودن کالا استفاده کنید</div>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>

              <!-- Cart Summary -->
              <div class="border-t border-amber-400/20 bg-gradient-to-r from-slate-900 to-slate-800 px-6 py-4">
                <div class="grid grid-cols-1 lg:grid-cols-4 gap-4 text-sm">
                  <div class="text-slate-300">
                    تعداد اقلام: <span class="text-slate-50 font-bold text-lg">{{ cartItems.length }}</span>
                  </div>
                  <div class="text-slate-300">
                    جمع اقلام: <span class="text-slate-50 font-bold text-lg">{{
                      subtotalBeforeDiscounts | toMoney(0)
                    }}</span>
                  </div>
                  <div v-if="totalLineDiscountAmount" class="text-rose-300">
                    تخفیف ردیف‌ها: <span class="font-bold text-lg">-{{ totalLineDiscountAmount | toMoney(0) }}</span>
                  </div>
                  <div class="text-slate-300">
                    جمع پس از تخفیف: <span
                      class="text-emerald-300 font-bold text-lg">{{ subtotalAfterLineDiscounts | toMoney(0) }}</span>
                  </div>
                  <div v-if="orderDiscountAmount" class="text-pink-300">
                    تخفیف کلی: <span class="font-bold text-lg">-{{ orderDiscountAmount | toMoney(0) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-show="activeTab === 'orders'"
             class="w-full max-w-none  rounded-2xl border border-white/10 bg-gradient-to-br from-slate-900/80 to-slate-800/70 backdrop-blur-2xl shadow-2xl shadow-black/40 flex flex-col overflow-hidden mx-4 my-2">
          <!-- Header -->
          <div class=" border-b border-white/10 bg-gradient-to-r from-slate-900 to-slate-800 px-6 py-4">
            <div class="flex items-center justify-between">
              <div class="flex items-center gap-3">
                <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"/>
                </svg>
                <div>
                  <h2 class="text-lg font-bold text-slate-50">لیست سفارش‌های حضوری</h2>
                  <p class="text-sm text-slate-300 mt-1">
                    جستجو، فیلتر و مشاهده جزئیات سفارش‌های ثبت‌شده
                  </p>
                </div>
              </div>

              <div class="text-sm text-slate-300 bg-slate-800/50 px-3 py-2 rounded-2xl border border-white/10">
                نمایش <span class="text-amber-300 font-bold">{{ orders.items.length }}</span> از
                <span class="text-emerald-300 font-bold">{{ orders.total }}</span> سفارش
              </div>
            </div>
          </div>

          <!-- Filters -->
          <div class="p-4 border-b border-white/10 bg-slate-900/60 flex flex-wrap gap-3 items-center">
            <select
                v-model="ordersFilters.status"
                class="px-3 py-2.5 bg-slate-800/80 text-sm rounded-2xl border border-white/10 w-40 text-right"
            >
              <option value="">همه وضعیت‌ها</option>
              <option value="dr">پیش‌نویس</option>
              <option value="cf">نهایی شده</option>
              <option value="ca">لغو شده</option>
              <option value="re">برگشت از خرید</option>
            </select>
            <div class="relative">
              <input
                  v-model="ordersFilters.search"
                  class="px-4 py-2.5 bg-slate-800/80 text-sm rounded-2xl border border-white/10 w-64 text-right placeholder-slate-400
                 focus:border-amber-400/50 focus:ring-2 focus:ring-amber-400/20 transition-all duration-200"
                  placeholder="جستجو  ..."
                  @keyup.enter="fetchOrders"
              />
              <svg class="w-4 h-4 text-slate-500 absolute left-3 top-1/2 transform -translate-y-1/2" fill="none"
                   stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
              </svg>
            </div>

            <!-- Date Filters -->
            <div class="flex items-center gap-2">
              <input
                  type="date"
                  v-model="ordersFilters.date_from"
                  class="px-3 py-2.5 bg-slate-800/80 text-sm rounded-2xl border border-white/10 w-40 text-right"
              />
              <span class="text-slate-400 text-sm">تا</span>
              <input
                  type="date"
                  v-model="ordersFilters.date_to"
                  class="px-3 py-2.5 bg-slate-800/80 text-sm rounded-2xl border border-white/10 w-40 text-right"
              />
            </div>

            <div class="flex items-center gap-2">
              <button
                  style="max-width: 120px"
                  @click="applyOrdersFilters"
                  class="flex-shrink-0 px-4 py-2.5 bg-gradient-to-r from-amber-500 to-amber-600 text-slate-950 text-sm rounded-md
                 hover:from-amber-400 hover:to-amber-500 transition-all duration-200 hover:scale-105
                 font-medium flex gap-2 items-center text-center"
              >
                <svg class="w-4 h-4" fill="none" stroke="white" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.207A1 1 0 013 6.5V4z"/>
                </svg>
                <span class="white--text">
                  اعمال فیلتر
                </span>
              </button>

              <button
                  style="max-width: 120px"
                  @click="clearOrdersFilters"
                  class="flex-shrink-0 px-4 py-2.5 bg-slate-800/80 text-slate-300 text-sm rounded-md border border-white/10
                 hover:bg-slate-700/80 hover:text-slate-100 transition-all duration-200 flex gap-2 items-center text-center"
              >
                حذف فیلتر
              </button>
            </div>
          </div>

          <!-- Table -->
          <div class="overflow-auto flex-1">
            <table class="w-full text-sm">
              <thead
                  class="bg-gradient-to-r from-slate-900 to-slate-800 border-b border-white/10 text-slate-200 sticky top-0">
              <tr>
                <th class="px-4 py-3 text-center">تاریخ ثبت</th>
                <th class="px-4 py-3 text-center">کد پیگیری</th>
                <th class="px-4 py-3 text-center">مشتری</th>
                <th class="px-4 py-3 text-centerr">مبلغ</th>
                <th class="px-4 py-3 text-centerr">وضعیت</th>
                <th class="px-4 py-3 text-centerr">عملیات</th>
              </tr>
              </thead>

              <tbody class="divide-y divide-white/5">
              <tr
                  v-for="o in orders.items"
                  :key="o.id"
                  class="hover:bg-slate-800/50 transition-all duration-200 group"
              >
                <!-- Date -->
                <td class="px-4 py-3 whitespace-nowrap">
                  <div class="text-slate-300 text-sm">{{ o.date_time || o.created_at || '---' }}</div>
                </td>

                <td class="px-1 py-2 text-center">
                  <span
                      class=" text-sm text-cyan-300 ">
                    {{ o.id }}
                  </span>
                </td>

                <!-- Customer -->
                <td class="px-4 py-3 whitespace-nowrap">
                  <div class="flex flex-col">
                    <span class="text-slate-100 font-medium text-sm">{{ o.customer_name || 'بدون نام' }}</span>
                    <span class="text-slate-400 text-xs mt-1">{{ o.customer_phone || '---' }}</span>
                  </div>
                </td>


                <!-- Final Amount -->
                <td class="px-1 py-2 text-center items-center">
                  <div class="text-emerald-300 font-bold text-sm">
                    {{ o.final_amount  | toMoney(0) }}
                  </div>
                </td>
                <td class=" text-center items-center ">
                  <span
                      class=" px-2 py-1 rounded-md  text-xs border"
                      :class="statusBadgeClass(o.status)"
                  >
                    {{ posStatusLabel(o.status) }}
                  </span>
                </td>
                <td class="px-2 py-1 text-center whitespace-nowrap">
                  <div class="flex items-center justify-center gap-2">
                    <button
                        @click="openOrderDetails(o)"
                        class="px-2 py-1 bg-slate-700/50 text-slate-200 text-sm rounded-md border border-white/10
                         hover:bg-slate-600/80 hover:text-white transition-all duration-200 hover:scale-105
                         group-hover:border-amber-400/30"
                    >
                      جزئیات سفارش
                    </button>

                    <button
                        @click="openSuccessModal(o)"
                        class="px-2 py-1 bg-slate-700/50 text-slate-200 text-sm rounded-md border border-white/10
                        hover:bg-slate-700/80 hover:text-white transition-all duration-200"
                    >
                      👀
                    </button>
                  </div>
                </td>
              </tr>

              <!-- Empty State -->
              <tr v-if="!orders.items.length && !loading.orders">
                <td colspan="8" class="px-4 py-12 text-center">
                  <div class="flex flex-col items-center justify-center text-slate-500">
                    <svg class="w-16 h-16 mb-4 opacity-50" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1"
                            d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"/>
                    </svg>
                    <p class="text-lg font-medium">سفارشی یافت نشد</p>
                    <p class="text-sm mt-2">هیچ سفارشی مطابق با فیلترهای شما وجود ندارد</p>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>

          <!-- Pagination -->
          <div class="flex items-center justify-between p-4 border-t border-white/10 bg-slate-900/60 text-slate-200">
            <div class="text-sm">
              صفحه
              <span class="font-bold text-amber-300 mx-1">{{ orders.page }}</span>
              از
              <span class="font-bold text-emerald-300 mx-1">{{ orders.total_pages }}</span>
            </div>

            <div class="flex items-center gap-2">
              <select
                  v-model.number="orders.page_size"
                  @change="goOrdersPage(1)"
                  class="px-3 py-2 border border-white/10 rounded-2xl text-sm bg-slate-800/80 focus:border-amber-400/50 focus:ring-2 focus:ring-amber-400/20"
              >
                <option :value="10">10 مورد</option>
                <option :value="25">25 مورد</option>
                <option :value="50">50 مورد</option>
              </select>

              <button
                  style="max-width: 50px"
                  @click="goOrdersPage(orders.page - 1)"
                  :disabled="orders.page === 1"
                  class="max-w-md px-4 py-2 bg-slate-800/80 border border-white/10 rounded-2xl text-sm disabled:opacity-50
                 hover:bg-slate-700/80 transition-all duration-200 flex items-center gap-2 text-center items-center"
              >
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
                </svg>
                قبلی
              </button>

              <button
                  style="max-width: 50px"
                  @click="goOrdersPage(orders.page + 1)"
                  :disabled="orders.page === orders.total_pages"
                  class="max-w-md px-4 py-2 bg-slate-800/80 border border-white/10 rounded-2xl text-sm disabled:opacity-50
                 hover:bg-slate-700/80 transition-all duration-200 flex items-center gap-2 text-center items-center"
              >
                بعدی
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/>
                </svg>
              </button>
            </div>
          </div>
        </div>

        <div v-show="activeTab === 'overview'"
             class="max-w-4xl rounded-xl border border-white/10 bg-slate-900/70 backdrop-blur-2xl shadow-2xl shadow-black/40 flex flex-col overflow-hidden">
          <div class="border-b border-white/5 px-6 py-4 bg-slate-900/60">
            <div class="flex items-center justify-between">
              <div>
                <h2 class="text-xl font-semibold text-slate-50">نمای کلی فروش حضوری</h2>
              </div>
            </div>
          </div>

          <div class="flex-1 p-16 min-h-0 grid grid-cols-1 md:grid-cols-4 gap-4">


            <div class="flex items-center justify-center">
              <div class="relative">
                <div
                    class="w-40 h-40 rounded-full border border-indigo-400/40 bg-gradient-to-br from-cyan-500/20 via-slate-900 to-cyan-900
               shadow-2xl shadow-cyan-500/30 flex items-center justify-center"
                >
                  <div class="w-28 h-28 rounded-full  flex flex-col items-center justify-center text-center px-4">
                    <div class="text-[11px] text-indigo-200/80 mb-1">
                      فروش امروز
                    </div>
                    <div class="text-xl font-bold text-cyan-200 leading-tight">
                      {{ overview.today_total | toMoney(0) }}
                    </div>
                    <div class="mt-1 text-[10px] text-cyan-100/70">
                      {{ overview.today_orders }} فاکتور
                    </div>
                  </div>
                </div>

                <div class="mt-3 text-center text-xs text-cyan-100/80">
                  فروش حضوری
                </div>
              </div>
            </div>
            <div class="flex items-center justify-center">
              <div class="relative">
                <div
                    class="w-40 h-40 rounded-full border border-indigo-400/40 bg-gradient-to-br from-indigo-500/20 via-slate-900 to-slate-900
               shadow-2xl shadow-indigo-500/30 flex items-center justify-center"
                >
                  <div class="w-28 h-28 rounded-full  flex flex-col items-center justify-center text-center px-4">
                    <div class="text-[11px] text-indigo-200/80 mb-1">
                      فروش دیروز
                    </div>
                    <div class="text-xl font-bold text-indigo-200 leading-tight">
                      {{ overview.yesterday_total | toMoney(0) }}
                    </div>
                    <div class="mt-1 text-[10px] text-indigo-100/70">
                      {{ overview.yesterday_orders }} فاکتور
                    </div>
                  </div>
                </div>

                <div class="mt-3 text-center text-xs text-indigo-100/80">
                  مقایسه با یک روز قبل (حضوری)
                </div>
              </div>
            </div>

            <div class="flex items-center justify-center">
              <div class="relative">
                <div
                    class="w-40 h-40 rounded-full border border-amber-400/40 bg-gradient-to-br from-amber-500/20 via-slate-900 to-slate-900
               shadow-2xl shadow-amber-500/30 flex items-center justify-center"
                >
                  <div class="w-28 h-28 rounded-full flex flex-col items-center justify-center text-center px-4">
                    <div class="text-[11px] text-amber-200/80 mb-1">
                      فروش این ماه
                    </div>
                    <div class="text-xl font-bold text-amber-200 leading-tight">
                      {{ overview.month_total | toMoney(0) }}
                    </div>
                    <div class="mt-1 text-[10px] text-indigo-100/70">
                      {{ overview.month_orders }} فاکتور
                    </div>

                  </div>
                </div>

                <div class="mt-3 text-center text-xs text-amber-100/80">
                  نمای کلی ماه جاری (حضوری)
                </div>
              </div>
            </div>
            <div class="flex items-center justify-center">
              <div class="relative">
                <div
                    class="w-40 h-40 rounded-full border border-purple-400/40 bg-gradient-to-br from-purple-500/20 via-slate-900 to-slate-900
               shadow-2xl shadow-purple-500/30 flex items-center justify-center"
                >
                  <div class="w-28 h-28 rounded-full flex flex-col items-center justify-center text-center px-4">
                    <div class="text-[11px] text-purple-200/80 mb-1">
                      میانگین سبد
                    </div>
                    <div class="text-xl font-bold text-purple-200 leading-tight">
                      {{ overview.avg_basket | toMoney(0) }}
                    </div>
                  </div>
                </div>

                <div class="mt-3 text-center text-xs text-purple-100/80">
                  نمای میانگین سبد ماه جاری (حضوری)
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <transition
        enter-active-class="transition-all duration-300 ease-out"
        leave-active-class="transition-all duration-200 ease-in"
        enter-class="opacity-0 scale-95"
        enter-to-class="opacity-100 scale-100"
        leave-class="opacity-100 scale-100"
        leave-to-class="opacity-0 scale-95"
    >
      <div
          v-if="showDiscountModal"
          class="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-xl p-4"
      >
        <div class="bg-gradient-to-br from-slate-900 to-slate-800 rounded-3xl border border-white/10 w-full max-w-md p-8
                text-slate-100 shadow-2xl shadow-pink-500/10 backdrop-blur-2xl relative overflow-hidden">

          <div class="absolute inset-0 opacity-5">
            <div class="absolute -top-20 -right-20 w-40 h-40 bg-pink-500 rounded-full blur-3xl"></div>
            <div class="absolute -bottom-20 -left-20 w-40 h-40 bg-cyan-500 rounded-full blur-3xl"></div>
          </div>

          <div class="relative z-10">
            <!-- Header -->
            <div class="text-center mb-6">
              <div
                  class="w-12 h-12 bg-gradient-to-r from-pink-500 to-purple-600 rounded-2xl flex items-center justify-center mx-auto mb-3 shadow-lg shadow-pink-500/30">
                <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/>
                </svg>
              </div>
              <h3 class="text-xl font-bold bg-gradient-to-r from-white to-slate-200 bg-clip-text text-transparent">
                تخفیف کلی فاکتور
              </h3>
              <p class="text-sm text-slate-400 mt-2 font-light leading-relaxed">
                نوع و مقدار تخفیف کلی روی مجموع فاکتور را مشخص کنید
              </p>
            </div>

            <div class="grid grid-cols-3 gap-3 mb-6">
              <button
                  @click="bulkDiscount.type = 'none'"
                  :class="[
                'p-4 rounded-2xl border-2 transition-all duration-300 group relative overflow-hidden',
                bulkDiscount.type === 'none'
                  ? 'border-pink-500 bg-pink-500/10 shadow-lg shadow-pink-500/20'
                  : 'border-white/10 bg-white/5 hover:border-white/20 hover:bg-white/10'
              ]"
              >
                <div class="text-center">
                  <div
                      class="w-8 h-8 rounded-full bg-slate-700 group-hover:bg-slate-600 mx-auto mb-2 flex items-center justify-center transition-colors">
                    <svg class="w-4 h-4 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
                    </svg>
                  </div>
                  <span class="text-xs font-medium text-slate-300 group-hover:text-white">بدون تخفیف</span>
                </div>
              </button>

              <button
                  @click="bulkDiscount.type = 'percent'"
                  :class="[
                'p-4 rounded-2xl border-2 transition-all duration-300 group relative overflow-hidden',
                bulkDiscount.type === 'percent'
                  ? 'border-cyan-500 bg-cyan-500/10 shadow-lg shadow-cyan-500/20'
                  : 'border-white/10 bg-white/5 hover:border-white/20 hover:bg-white/10'
              ]"
              >
                <div class="text-center">
                  <div
                      class="w-8 h-8 rounded-full bg-slate-700 group-hover:bg-slate-600 mx-auto mb-2 flex items-center justify-center transition-colors">
                    <span class="text-xs font-bold text-slate-400">%</span>
                  </div>
                  <span class="text-xs font-medium text-slate-300 group-hover:text-white">درصدی</span>
                </div>
              </button>

              <button
                  @click="bulkDiscount.type = 'amount'"
                  :class="[
                'p-4 rounded-2xl border-2 transition-all duration-300 group relative overflow-hidden',
                bulkDiscount.type === 'amount'
                  ? 'border-purple-500 bg-purple-500/10 shadow-lg shadow-purple-500/20'
                  : 'border-white/10 bg-white/5 hover:border-white/20 hover:bg-white/10'
              ]"
              >
                <div class="text-center">
                  <div
                      class="w-8 h-8 rounded-full bg-slate-700 group-hover:bg-slate-600 mx-auto mb-2 flex items-center justify-center transition-colors">
                    <span class="text-xs font-bold text-slate-400">ت</span>
                  </div>
                  <span class="text-xs font-medium text-slate-300 group-hover:text-white">مبلغی</span>
                </div>
              </button>
            </div>

            <div v-if="bulkDiscount.type !== 'none'" class="mb-6">
              <label class="block text-sm font-medium text-slate-300 mb-3">
                <span v-if="bulkDiscount.type === 'percent'">🎯 درصد تخفیف</span>
                <span v-else>💰 مبلغ تخفیف (تومان)</span>
              </label>
              <div class="relative">
                <input
                    type="number"
                    step="0.01"
                    v-model.number="bulkDiscount.value"
                    class="w-full px-4 py-4 pr-12 border border-white/10 rounded-2xl text-lg bg-slate-800/50
                     text-white placeholder-slate-400 backdrop-blur-xl focus:border-pink-400/50
                     focus:ring-2 focus:ring-pink-400/20 transition-all duration-200 font-medium"
                    :placeholder="bulkDiscount.type === 'percent' ? 'مثلاً ۱۵' : 'مثلاً ۵۰۰۰۰'"
                />
                <div class="absolute left-4 top-1/2 transform -translate-y-1/2 text-slate-400">
                  <span v-if="bulkDiscount.type === 'percent'">%</span>
                  <span v-else>ت</span>
                </div>
              </div>
            </div>

            <!-- Preview (Optional) -->
            <div v-if="bulkDiscount.type !== 'none' && bulkDiscount.value"
                 class="bg-slate-800/30 rounded-2xl p-4 mb-6 border border-white/5">
              <div class="flex justify-between items-center text-sm">
                <span class="text-slate-400">مقدار تخفیف:</span>
                <span class="font-bold text-green-400">
              <span v-if="bulkDiscount.type === 'percent'">{{ bulkDiscount.value }}%</span>
              <span v-else>{{ bulkDiscount.value.toLocaleString() }} تومان</span>
            </span>
              </div>
            </div>

            <!-- Actions -->
            <div class="flex gap-3">
              <button
                  @click="showDiscountModal = false"
                  class="flex-1 px-6 py-3.5 rounded-2xl bg-slate-800 text-slate-300 hover:bg-slate-700 hover:text-white
                   text-sm font-medium transition-all duration-200 border border-white/5 hover:border-white/10
                   hover:scale-[1.02] active:scale-[0.98]"
              >
                انصراف
              </button>
              <button
                  @click="applyBulkDiscount"
                  class="flex-1 px-6 py-3.5 rounded-2xl bg-gradient-to-r from-pink-500 to-purple-600
                   text-white hover:from-pink-400 hover:to-purple-500 text-sm font-medium transition-all duration-200
                   hover:scale-[1.02] active:scale-[0.98] shadow-lg shadow-pink-500/30 hover:shadow-pink-500/40
                   flex items-center justify-center gap-2"
              >
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                </svg>
                اعمال تخفیف
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <!-- Bulk Wholesale Modal -->
    <transition
        enter-active-class="transition-all duration-300 ease-out"
        leave-active-class="transition-all duration-200 ease-in"
        enter-class="opacity-0 scale-95"
        enter-to-class="opacity-100 scale-100"
        leave-class="opacity-100 scale-100"
        leave-to-class="opacity-0 scale-95"
    >
      <div
          v-if="showWholesaleModal"
          class="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-xl p-4"
      >
        <div class="bg-gradient-to-br from-slate-900 to-amber-900/20 rounded-3xl border border-amber-400/20 w-full max-w-md p-8
                text-slate-100 shadow-2xl shadow-amber-500/10 backdrop-blur-2xl relative overflow-hidden">

          <!-- Background Decoration -->
          <div class="absolute inset-0 opacity-10">
            <div class="absolute -top-20 -right-20 w-40 h-40 bg-amber-500 rounded-full blur-3xl"></div>
            <div class="absolute -bottom-20 -left-20 w-40 h-40 bg-orange-500 rounded-full blur-3xl"></div>
          </div>

          <div class="relative z-10">
            <!-- Header -->
            <div class="text-center mb-6">
              <div
                  class="w-12 h-12 bg-gradient-to-r from-amber-500 to-orange-600 rounded-2xl flex items-center justify-center mx-auto mb-3 shadow-lg shadow-amber-500/30">
                <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"/>
                </svg>
              </div>
              <h3 class="text-xl font-bold bg-gradient-to-r from-amber-200 to-amber-100 bg-clip-text text-transparent">
                سود عمده‌فروشی
              </h3>
              <p class="text-sm text-slate-300 mt-2 font-light leading-relaxed">
                درصد سود عمده را مشخص کنید تا روی تمام ردیف‌ها اعمال شود
              </p>
            </div>

            <div class="mb-6">
              <div @click="bulkWholesale.enabled = !bulkWholesale.enabled"
                   :class="[
                 'relative inline-flex items-center w-16 h-8 rounded-full transition-all duration-300 cursor-pointer border-2',
                 bulkWholesale.enabled
                   ? 'bg-amber-500/20 border-amber-400/50 shadow-lg shadow-amber-500/20'
                   : 'bg-slate-800/50 border-slate-600/50'
               ]">
                <div :class="[
              'absolute top-1/2 transform -translate-y-1/2 w-6 h-6 rounded-full transition-all duration-300 flex items-center justify-center',
              bulkWholesale.enabled
                ? 'left-8 bg-amber-400 shadow-lg shadow-amber-400/50'
                : 'left-1 bg-slate-500'
            ]">
                  <svg v-if="bulkWholesale.enabled" class="w-3 h-3 text-amber-900" fill="currentColor"
                       viewBox="0 0 20 20">
                    <path fill-rule="evenodd"
                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                          clip-rule="evenodd"/>
                  </svg>
                  <svg v-else class="w-3 h-3 text-slate-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
                  </svg>
                </div>
              </div>
              <span class="mr-3 text-sm font-medium text-slate-300">فعال‌سازی حالت عمده</span>
            </div>

            <!-- Margin Input -->
            <div v-if="bulkWholesale.enabled" class="space-y-4">
              <div class="bg-amber-500/10 border border-amber-400/20 rounded-2xl p-4">
                <label class="block text-sm font-medium text-amber-200 mb-3 flex items-center gap-2">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/>
                  </svg>
                  درصد سود از قیمت پایه
                </label>

                <div class="relative">
                  <input
                      type="number"
                      step="0.1"
                      v-model.number="bulkWholesale.margin_percent"
                      class="w-full px-4 py-4 pr-12 border border-amber-400/30 rounded-2xl text-lg bg-amber-500/10
                       text-amber-100 placeholder-amber-400/50 backdrop-blur-xl focus:border-amber-400/60
                       focus:ring-2 focus:ring-amber-400/20 transition-all duration-200 font-medium"
                      placeholder="مثلاً ۲۰"
                  />
                  <div class="absolute left-4 top-1/2 transform -translate-y-1/2 text-amber-400 font-bold">
                    %
                  </div>
                </div>

                <!-- Quick Percentage Buttons -->
                <div class="flex gap-2 mt-3">
                  <button
                      v-for="percent in [10, 15, 20, 25]"
                      :key="percent"
                      @click="bulkWholesale.margin_percent = percent"
                      :class="[
                    'flex-1 px-3 py-2 rounded-xl text-xs font-medium transition-all duration-200',
                    bulkWholesale.margin_percent === percent
                      ? 'bg-amber-500 text-amber-900 shadow-lg shadow-amber-500/30'
                      : 'bg-amber-500/20 text-amber-300 hover:bg-amber-500/30 border border-amber-400/20'
                  ]"
                  >
                    {{ percent }}%
                  </button>
                </div>
              </div>

              <!-- Preview -->
              <div v-if="bulkWholesale.margin_percent" class="bg-slate-800/30 rounded-2xl p-4 border border-white/5">
                <div class="flex justify-between items-center text-sm">
                  <span class="text-slate-400">سود اعمال شده:</span>
                  <span class="font-bold text-amber-400">
                {{ bulkWholesale.margin_percent }}%
              </span>
                </div>
                <div class="text-xs text-slate-500 mt-1 text-left">
                  این درصد به تمام محصولات فاکتور اضافه خواهد شد
                </div>
              </div>
            </div>

            <!-- Info Box when disabled -->
            <div v-else class="bg-slate-800/30 rounded-2xl p-4 border border-slate-600/50">
              <div class="flex items-start gap-3">
                <svg class="w-5 h-5 text-slate-500 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor"
                     viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
                </svg>
                <div class="text-sm text-slate-400">
                  با فعال‌سازی این گزینه، می‌توانید سود عمده‌فروشی را به صورت یکجا روی تمام محصولات اعمال کنید.
                </div>
              </div>
            </div>

            <!-- Actions -->
            <div class="flex gap-3 mt-6">
              <button
                  @click="showWholesaleModal = false"
                  class="flex-1 px-6 py-3.5 rounded-2xl bg-slate-800 text-slate-300 hover:bg-slate-700 hover:text-white
                   text-sm font-medium transition-all duration-200 border border-white/5 hover:border-white/10
                   hover:scale-[1.02] active:scale-[0.98]"
              >
                انصراف
              </button>
              <button
                  @click="applyBulkWholesale"
                  :disabled="!bulkWholesale.enabled"
                  :class="[
                'flex-1 px-6 py-3.5 rounded-2xl text-sm font-medium transition-all duration-200',
                'hover:scale-[1.02] active:scale-[0.98] flex items-center justify-center gap-2',
                bulkWholesale.enabled
                  ? 'bg-gradient-to-r from-amber-500 to-orange-600 text-slate-950 shadow-lg shadow-amber-500/30 hover:shadow-amber-500/40'
                  : 'bg-slate-700 text-slate-500 cursor-not-allowed'
              ]"
              >
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                </svg>
                اعمال سود
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <!-- Order Success Modal -->
    <transition
        enter-active-class="transition-all duration-300 ease-out"
        leave-active-class="transition-all duration-200 ease-in"
        enter-class="opacity-0"
        enter-to-class="opacity-100"
        leave-class="opacity-100"
        leave-to-class="opacity-0"
    >
      <div
          v-if="orderSuccess.visible"
          class="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-md p-4"
          dir="rtl"
      >
        <div class="w-full max-w-lg bg-slate-950/95 rounded-3xl border border-white/10 shadow-2xl overflow-hidden">
          <div class="p-6 border-b border-white/10 bg-gradient-to-b from-slate-900/70 to-transparent">
            <div class="flex items-start justify-between gap-4">
              <div class="min-w-0">
                <div class="flex items-center gap-2 flex-wrap mb-2">
                  <h3 class="text-lg font-bold text-slate-50">
                    {{ successHeader.title }}
                  </h3>
                </div>
                <span class="flex-shrink-0 text-xs text-slate-400 mb-1">
                        کد پیگیری
                        :
                        <span class="text-sm text-slate-200">
                          {{ successOrder.id }}
                        </span>
                      </span>

                <span class="text-xs text-slate-400 mb-1 mr-5">
                        تاریخ سفارش
                        :
                        <span class="text-sm text-slate-200">
                          {{ successOrder.created_at }}
                        </span>
                      </span>
              </div>

              <div class="flex-shrink-0">
                <div
                    class="text-center p-3 rounded-xl bg-slate-900/60 border border-white/10 min-w-[120px] items-center text-center">
                  <div class="text-xs text-slate-400 mb-2 text-center">وضعیت فعلی</div>
                  <div class="text-lg font-bold text-center" :class="getStatusColor(successOrder.status)">
                    {{ getStatusText(successOrder.status) }}
                  </div>
                </div>
              </div>
            </div>

            <div class="mt-6 p-4 rounded-2xl bg-gradient-to-r from-slate-900/60 to-slate-800/40 border border-white/10">
              <div class="flex items-center justify-between mb-4">
                <div>
                  <div class="text-sm font-semibold text-slate-100">تغییر وضعیت سفارش</div>
                </div>

                <div class="hidden md:flex items-center gap-2 text-xs"
                     v-if="successOrder.status == 'dr' || successOrder.status == 'cf'">
                  <div class="flex items-center gap-1">
                    <div class="w-2 h-2 rounded-full"
                         :class="successOrder.status == 'dr'? 'bg-amber-500': 'bg-slate-500'"></div>
                    <span :class="successOrder.status == 'dr'? 'text-slate-300': 'text-slate-100/50'">پیش‌نویس</span>
                  </div>
                  <div class="text-slate-600">←</div>
                  <div class="flex items-center gap-1">
                    <div class="w-2 h-2 rounded-full"
                         :class="successOrder.status == 'cf'? 'bg-green-500': 'bg-slate-500'"></div>
                    <span :class="successOrder.status == 'cf'? 'text-slate-300': 'text-slate-100/50'">نهایی</span>
                  </div>
                </div>
              </div>

              <!-- وضعیت: پیش‌نویس -->
              <template v-if="successOrder.status === 'dr'">
                <div class="mb-4 p-3 rounded-md bg-slate-800/30 border border-white/5">
                  <div class="flex items-center gap-2 mb-3">
                    <div class="w-8 h-8 rounded-full bg-amber-500/20 flex items-center justify-center"
                         style="max-width: 30px">
                      <svg class="w-4 h-4 text-amber-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                      </svg>
                    </div>
                    <div>
                      <div class="text-sm font-medium text-slate-100">سفارش در وضعیت پیش‌نویس</div>
                      <div class="text-xs text-slate-400">لطفاً وضعیت را نهایی کنید یا در صورت نیاز لغو نمایید</div>
                    </div>
                  </div>

                  <div class="flex flex-wrap gap-3">
                    <button
                        type="button"
                        @click="applySuccessStatus('ca')"
                        :disabled="successStatusLoading"
                        class="px-5 py-2.5 rounded-md items-center text-sm font-semibold bg-rose-500/20 text-rose-200
                   border border-rose-400/30 hover:bg-rose-500/30 hover:border-rose-400/50
                   active:scale-[0.98] transition-all duration-200 disabled:opacity-60
                   disabled:cursor-not-allowed flex items-center gap-2"
                    >
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
                      </svg>
                      لغو سفارش
                    </button>
                    <button
                        type="button"
                        @click="applySuccessStatus('cf')"
                        :disabled="successStatusLoading"
                        class="px-5 py-2.5 rounded-md items-center text-sm font-semibold bg-gradient-to-r from-emerald-500 to-teal-600
                        text-slate-950 hover:shadow-lg hover:shadow-emerald-500/30 active:scale-[0.98]
                        transition-all duration-200 disabled:opacity-60 disabled:cursor-not-allowed
                        flex items-center gap-2 min-w-[120px] justify-center"
                    >
                      <svg v-if="successStatusLoading" class="w-4 h-4 animate-spin" fill="none" stroke="currentColor"
                           viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                              d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
                      </svg>
                      <svg v-else class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                      </svg>
                      {{ successStatusLoading ? 'در حال انجام...' : 'نهایی کردن سفارش' }}
                    </button>

                  </div>
                </div>
              </template>

              <template v-else-if="successOrder.status === 'cf'">
                <div class="mb-4 p-3 rounded-xl bg-slate-800/30 border border-amber-500/20">
                  <div class="flex items-center gap-2 mb-3">
                    <div class="w-8 h-8 rounded-full bg-amber-500/20 flex items-center justify-center">
                      <svg class="w-4 h-4 text-amber-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                              d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"/>
                      </svg>
                    </div>
                    <div>
                      <div class="text-sm font-medium text-slate-100">سفارش تأیید شده</div>
                      <div class="text-xs text-slate-400">در صورت مرجوعی خریدار، وضعیت را تغییر دهید</div>
                    </div>
                  </div>

                  <div class="flex flex-wrap gap-3">
                    <button
                        type="button"
                        @click="applySuccessStatus('re')"
                        :disabled="successStatusLoading"
                        class="px-5 py-2.5 rounded-xl text-sm font-semibold bg-gradient-to-r from-amber-500 to-orange-600
                   text-slate-950 hover:shadow-lg hover:shadow-amber-500/30 active:scale-[0.98]
                   transition-all duration-200 disabled:opacity-60 disabled:cursor-not-allowed
                   flex items-center gap-2"
                    >
                      <svg v-if="successStatusLoading" class="w-4 h-4 animate-spin" fill="none" stroke="currentColor"
                           viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                              d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
                      </svg>
                      <svg v-else class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                              d="M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6"/>
                      </svg>
                      {{ successStatusLoading ? 'در حال انجام...' : 'ثبت مرجوعی' }}
                    </button>
                  </div>
                </div>
              </template>

              <template v-if="successOrder.status === 're' || successOrder.status === 'ca'">
                <div class="p-4 rounded-xl bg-slate-800/40 border"
                     :class="successOrder.status === 'ca' ? 'border-rose-500/20' : 'border-indigo-500/20'">
                  <div class="flex items-center gap-3">
                    <div class="w-10 h-10 rounded-md flex items-center justify-center" style="max-width: 50px"
                         :class="successOrder.status === 'ca' ? 'bg-rose-500/20' : 'bg-indigo-500/20'">
                      <svg class="w-5 h-5" :class="successOrder.status === 'ca' ? 'text-rose-400' : 'text-indigo-400'"
                           fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path v-if="successOrder.status === 'ca'" stroke-linecap="round" stroke-linejoin="round"
                              stroke-width="2"
                              d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"/>
                        <path v-else stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                              d="M16 15v-1a4 4 0 00-4-4H8m0 0l3 3m-3-3l3-3m9 14V5a2 2 0 00-2-2H6a2 2 0 00-2 2v16l4-2 4 2 4-2 4 2z"/>
                      </svg>
                    </div>
                    <div class="flex-1">
                      <div class="text-sm font-medium"
                           :class="successOrder.status === 'ca' ? 'text-rose-200' : 'text-indigo-200'">
                        {{ successOrder.status === 'ca' ? 'سفارش لغو شده' : 'سفارش برگشت خورده ' }}
                      </div>
                      <div class="text-xs mt-1"
                           :class="successOrder.status === 'ca' ? 'text-rose-300/70' : 'text-indigo-300/70'">
                        {{ lockedStatusMessage }}
                      </div>
                    </div>
                  </div>
                </div>
              </template>

              <!-- نمایش خطا -->
              <div v-if="successStatusError" class="mt-4 p-3 rounded-xl bg-rose-500/10 border border-rose-500/20">
                <div class="flex items-center gap-2">
                  <svg class="w-4 h-4 text-rose-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
                  </svg>
                  <div class="text-xs text-rose-300">{{ successStatusError }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="p-6 space-y-4">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
              <div class="rounded-2xl bg-slate-900/60 border border-white/10 p-4">
                <div class="text-[11px] text-slate-400 mb-2">اطلاعات مشتری</div>
                <div class="text-sm font-semibold text-slate-100 truncate">
                  {{ successCustomerName || '---' }}
                </div>
                <div class="mt-1 text-xs text-slate-300 ">
                  {{ successCustomerPhone || '---' }}
                </div>
              </div>

              <div class="rounded-2xl bg-slate-900/60 border border-white/10 p-4">
                <div class="text-[11px] text-slate-400 mb-2">خلاصه پرداخت</div>
                <div class="flex justify-between text-xs">
                  <span class="text-slate-400">جمع ردیف‌ها</span>
                  <span class="text-slate-100 font-medium">{{
                      (successOrder.total_items_price || 0)  | toMoney(0)
                    }}</span>
                </div>
                <div class="flex justify-between text-xs mt-1">
                  <span class="text-slate-400">تخفیف ردیف‌ها</span>
                  <span class="text-emerald-300 font-medium">{{
                      (successOrder.total_line_discount || 0)  | toMoney(0)
                    }}</span>
                </div>
                <div class="flex justify-between text-xs mt-1">
                  <span class="text-slate-400">تخفیف کلی</span>
                  <span class="text-emerald-300 font-medium">{{
                      (successOrder.total_order_discount || 0)  | toMoney(0)
                    }}</span>
                </div>
                <div class="flex justify-between mt-2 pt-2 border-t border-white/10">
                  <span class="text-slate-200 font-semibold text-sm">مبلغ نهایی</span>
                  <span class="text-emerald-300 font-bold text-base">
                {{ (successOrder.final_amount || grandTotal || 0)  | toMoney(0) }}
              </span>
                </div>
              </div>
            </div>

            <!-- Actions -->
            <div class="grid grid-cols-1 md:grid-cols-2 gap-3 pt-1">
              <button
                  type="button"
                  @click="openOrderDetails(successOrder)"
                  class="text-center items-center px-4 py-3 rounded-2xl bg-slate-900 text-slate-100 hover:bg-slate-800 border border-white/10 transition-all duration-200 text-sm font-semibold"
              >
                مشاهده جزئیات سفارش
              </button>

              <button
                  type="button"
                  @click="printFromSuccess"
                  class="text-center items-center px-4 py-3 rounded-2xl bg-indigo-500 text-white hover:bg-indigo-400 transition-all duration-200 text-sm font-semibold"
              >
                {{ successPrintLabel }}
              </button>

              <button
                  type="button"
                  @click="copyOrderLink(successOrder)"
                  class="text-center items-center px-4 py-3 rounded-2xl bg-slate-800 text-slate-100 hover:bg-slate-700 border border-white/10 transition-all duration-200 text-sm"
              >
                کپی لینک فاکتور
              </button>

              <button
                  type="button"
                  @click="closeOrderSuccessModal"
                  class="text-center items-center px-4 py-3 rounded-2xl border border-white/10 text-slate-100 hover:bg-slate-900 transition-all duration-200 text-sm"
              >
                بستن و ثبت سفارش جدید
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <!-- Pretty Confirm Modal -->
    <transition
        enter-active-class="transition-all duration-300 ease-out"
        leave-active-class="transition-all duration-200 ease-in"
        enter-class="opacity-0 scale-95"
        enter-to-class="opacity-100 scale-100"
        leave-class="opacity-100 scale-100"
        leave-to-class="opacity-0 scale-95"
    >
      <div
          v-if="confirmModal.visible"
          class="fixed inset-0 z-[60] flex items-center justify-center bg-black/60 backdrop-blur-xl p-4"
          dir="rtl"
          @click.self="closeConfirmModal"
      >
        <div
            class="w-full max-w-md rounded-3xl border border-white/10 bg-slate-950/95 shadow-2xl overflow-hidden"
        >
          <!-- Header -->
          <div class="p-5 border-b border-white/10" :class="confirmTheme.headerBg">
            <div class=" items-start gap-3">
              <div class="min-w-0 ">
                <div class="text-[11px] text-slate-400">تأیید تغییر وضعیت</div>
                <div class="mt-1 text-base font-bold text-slate-50">
                  {{ confirmModal.title }}
                </div>
                <div class="mt-1 text-xs" :class="confirmTheme.subtitle">
                  {{ confirmModal.subtitle }}
                </div>
              </div>
            </div>
          </div>

          <!-- Body -->
          <div class="p-5 space-y-4">
            <div class="rounded-2xl bg-slate-900/60 border border-white/10 p-4">
              <div class="text-[11px] text-slate-400 mb-3">با انجام این کار:</div>

              <ul class="space-y-2 text-sm text-slate-200">
                <li v-for="(b, idx) in confirmModal.bullets" :key="idx" class="flex items-start gap-2">
                  <span class="mt-1 w-1.5 h-1.5 rounded-full" :class="confirmTheme.dot"></span>
                  <span class="leading-6">{{ b }}</span>
                </li>
              </ul>
            </div>

            <div class="flex gap-3">
              <button
                  type="button"
                  @click="closeConfirmModal"
                  :disabled="confirmModal.loading"
                  class="flex-1 px-4 py-2.5 rounded-2xl bg-slate-800 text-slate-200 hover:bg-slate-700 border border-white/10 text-sm font-semibold transition-all duration-200 disabled:opacity-60 disabled:cursor-not-allowed text-center items-center"
              >
                انصراف
              </button>

              <button
                  type="button"
                  @click="confirmStatusChange"
                  :disabled="confirmModal.loading"
                  class="flex-1 px-4 py-2.5 rounded-2xl text-slate-950 text-sm font-bold transition-all duration-200 active:scale-95 disabled:opacity-60 disabled:cursor-not-allowed text-center items-center"
                  :class="confirmTheme.confirmBtn"
              >
                {{ confirmModal.loading ? 'در حال انجام...' : confirmModal.confirmText }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <PosOrderDetailsModal
        ref="orderDetailsModal"
        :api-get-pos="apiGetPos"
        :api-patch-pos="apiPatchPos"
        :api-post-pos="apiPostPos"
        :api-delete-pos="apiDeletePos"
        :pos-status-label="posStatusLabel"
        :format-currency="formatCurrency"
        :toast="toast"
        :refresh-orders="fetchOrders"
    />
    <!-- Item Wholesale Modal -->
    <transition
        enter-active-class="transition-all duration-300 ease-out"
        leave-active-class="transition-all duration-200 ease-in"
        enter-class="opacity-0 scale-95"
        enter-to-class="opacity-100 scale-100"
        leave-class="opacity-100 scale-100"
        leave-to-class="opacity-0 scale-95"
    >
      <div
          v-if="showItemWholesaleModal"
          class="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-xl p-4"
          @click.self="showItemWholesaleModal = false; itemModalTarget = null"
      >
        <div class="bg-gradient-to-br from-slate-900 to-amber-900/20 rounded-3xl border border-amber-400/20 w-full max-w-md p-8
                text-slate-100 shadow-2xl shadow-amber-500/10 backdrop-blur-2xl relative overflow-hidden">

          <!-- Background Decoration -->
          <div class="absolute inset-0 opacity-10">
            <div class="absolute -top-20 -right-20 w-40 h-40 bg-amber-500 rounded-full blur-3xl"></div>
            <div class="absolute -bottom-20 -left-20 w-40 h-40 bg-orange-500 rounded-full blur-3xl"></div>
          </div>

          <div class="relative z-10">
            <!-- Header (اسم + عکس محصول مثل تخفیف آیتم) -->
            <div class="text-center mb-6">
              <div class="flex items-center justify-center gap-3 mb-3">
                <div class="w-12 h-12 rounded-2xl overflow-hidden border border-amber-400/40 bg-slate-800">
                  <img
                      v-if="itemModalProductImage()"
                      :src="img_source(itemModalProductImage())"
                      alt="img"
                      class="w-full h-full object-cover"
                  />
                  <div v-else class="w-full h-full flex items-center justify-center text-slate-400 text-xs">
                    ---
                  </div>
                </div>
                <div class="text-right">
                  <div class="text-xs text-amber-200 font-semibold mb-1">
                    تنظیم سود عمده این کالا
                  </div>
                  <div class="text-base font-bold text-slate-50 truncate max-w-[180px]">
                    {{ itemModalProductName() }}
                  </div>
                </div>
              </div>
              <p class="text-xs text-slate-300 mt-1 font-light leading-relaxed">
                حالت عمده و درصد سود را فقط برای همین ردیف .
              </p>
            </div>

            <div class="mb-6">
              <div
                  @click="itemWholesaleForm.is_wholesale = !itemWholesaleForm.is_wholesale"
                  :class="[
                    'relative inline-flex items-center w-16 h-8 rounded-full transition-all duration-300 cursor-pointer border-2',
                    itemWholesaleForm.is_wholesale
                      ? 'bg-amber-500/20 border-amber-400/50 shadow-lg shadow-amber-500/20'
                      : 'bg-slate-800/50 border-slate-600/50'
                  ]"
              >
                <div
                    :class="[
                      'absolute top-1/2 transform -translate-y-1/2 w-6 h-6 rounded-full transition-all duration-300 flex items-center justify-center',
                      itemWholesaleForm.is_wholesale
                        ? 'left-8 bg-amber-400 shadow-lg shadow-amber-400/50'
                        : 'left-1 bg-slate-500'
                    ]"
                >
                  <svg v-if="itemWholesaleForm.is_wholesale" class="w-3 h-3 text-amber-900" fill="currentColor"
                       viewBox="0 0 20 20">
                    <path fill-rule="evenodd"
                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                          clip-rule="evenodd"/>
                  </svg>
                  <svg v-else class="w-3 h-3 text-slate-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
                  </svg>
                </div>
              </div>
              <span class="mr-3 text-sm font-medium text-slate-300">
                فعال‌سازی حالت عمده برای این ردیف
              </span>
            </div>

            <!-- Form وقتی عمده فعاله -->
            <div v-if="itemWholesaleForm.is_wholesale" class="space-y-4">
              <div class="bg-amber-500/10 border border-amber-400/20 rounded-2xl p-4">
                <div class="flex flex-col gap-2 text-sm text-slate-300 mt-3">
                  <div>
                    <span class="text-slate-400">قیمت پایه: </span>
                    <span class="font-bold text-slate-100">{{ itemWholesaleForm.base | toMoney(0) }}</span>
                  </div>

                  <div>
                    <span class="text-slate-400">حاشیه سود : </span>
                    <span class="font-bold text-slate-100">{{ itemWholesaleForm.profit_margin }}٪</span>
                  </div>

                  <div>
                    <span class="text-slate-400">قیمت عمده نهایی: </span>
                    <span class="font-bold text-emerald-300">
                      {{ calcWholesalePrice(itemWholesaleForm) | toMoney(0) }}
                    </span>
                  </div>
                </div>

                <label class="block text-sm font-medium text-amber-200 mb-3 flex items-center gap-2 mt-2 ">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/>
                  </svg>
                  درصد سود از قیمت پایه
                </label>

                <div class="relative">
                  <input
                      type="number"
                      step="0.1"
                      v-model.number="itemWholesaleForm.profit_margin"
                      class="w-full px-4 py-4 pr-12 border border-amber-400/30 rounded-2xl text-lg bg-amber-500/10
                       text-amber-100 placeholder-amber-400/50 backdrop-blur-xl focus:border-amber-400/60
                       focus:ring-2 focus:ring-amber-400/20 transition-all duration-200 font-medium"
                      placeholder="مثلاً ۲۰"
                  />
                  <div class="absolute left-4 top-1/2 transform -translate-y-1/2 text-amber-400 font-bold">
                    %
                  </div>
                </div>

                <div class="flex gap-2 mt-3">
                  <button
                      v-for="percent in [10, 15, 20, 25]"
                      :key="percent"
                      @click="itemWholesaleForm.profit_margin = percent"
                      :class="[
                        'flex-1 px-3 py-2 rounded-xl text-xs font-medium transition-all duration-200',
                        itemWholesaleForm.profit_margin === percent
                          ? 'bg-amber-500 text-amber-900 shadow-lg shadow-amber-500/30'
                          : 'bg-amber-500/20 text-amber-300 hover:bg-amber-500/30 border border-amber-400/20'
                      ]"
                  >
                    {{ percent }}%
                  </button>
                </div>
              </div>
              <div
                  v-if="itemWholesaleForm.profit_margin && itemWholesalePreviewPrice()"
                  class="bg-slate-800/30 rounded-2xl p-4 border border-white/5 space-y-2"
              >
                <div class="flex justify-between items-center text-sm">
                  <span class="text-slate-400">سود اعمال شده:</span>
                  <span class="font-bold text-amber-400">
                    {{ itemWholesaleForm.profit_margin }}%
                  </span>
                </div>
                <div class="flex justify-between items-center text-sm">
                  <span class="text-slate-400">قیمت واحد با این سود:</span>
                  <span class="font-bold text-emerald-300">
                    {{ itemWholesalePreviewPrice() | toMoney(0) }}
                  </span>
                </div>
                <div class="text-xs text-slate-500 mt-1 text-left">
                  این تغییر فقط روی همین کالا اعمال می‌شود.
                </div>
              </div>
            </div>

            <!-- Info Box وقتی عمده خاموش است -->
            <div v-else class="bg-slate-800/30 rounded-2xl p-4 border border-slate-600/50">
              <div class="flex items-start gap-3">
                <svg class="w-5 h-5 text-slate-500 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor"
                     viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
                </svg>
                <div class="text-sm text-slate-400">
                  با فعال‌سازی این گزینه، این ردیف به عنوان «عمده» ثبت می‌شود و قیمت واحدش بر اساس سود تنظیم می‌شود.
                </div>
              </div>
            </div>

            <!-- Actions -->
            <div class="flex gap-3 mt-6">
              <button
                  @click="showItemWholesaleModal = false; itemModalTarget = null"
                  class="flex-1 px-6 py-3.5 rounded-2xl bg-slate-800 text-slate-300 hover:bg-slate-700 hover:text-white
                         text-sm font-medium transition-all duration-200 border border-white/5 hover:border-white/10
                         hover:scale-[1.02] active:scale-[0.98]"
              >
                انصراف
              </button>
              <button
                  @click="applyItemWholesale"
                  class="flex-1 px-6 py-3.5 rounded-2xl bg-gradient-to-r from-amber-500 to-orange-600
                         text-slate-950 hover:from-amber-400 hover:to-orange-500 text-sm font-medium transition-all duration-200
                         hover:scale-[1.02] active:scale-[0.98] shadow-lg shadow-amber-500/30 hover:shadow-amber-500/40
                         flex items-center justify-center gap-2"
              >
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                </svg>
                اعمال سود
              </button>
            </div>

          </div>
        </div>
      </div>
    </transition>
    <!-- Item Discount Modal -->
    <transition
        enter-active-class="transition-all duration-300 ease-out"
        leave-active-class="transition-all duration-200 ease-in"
        enter-class="opacity-0 scale-95"
        enter-to-class="opacity-100 scale-100"
        leave-class="opacity-100 scale-100"
        leave-to-class="opacity-0 scale-95"
    >
      <div
          v-if="showItemDiscountModal"
          class="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-xl p-4"
          @click.self="showItemDiscountModal = false"
      >
        <div class="bg-gradient-to-br from-slate-900 to-slate-800 rounded-3xl border border-white/10 w-full max-w-md p-8
            text-slate-100 shadow-2xl shadow-pink-500/10 backdrop-blur-2xl relative overflow-hidden">

          <!-- Background Decoration (مثل کلی) -->
          <div class="absolute inset-0 opacity-5">
            <div class="absolute -top-20 -right-20 w-40 h-40 bg-pink-500 rounded-full blur-3xl"></div>
            <div class="absolute -bottom-20 -left-20 w-40 h-40 bg-cyan-500 rounded-full blur-3xl"></div>
          </div>

          <div class="relative z-10">
            <!-- Header (اسم + عکس محصول) -->
            <div class="text-center mb-6">
              <div class="flex items-center justify-center gap-3 mb-3">
                <div class="w-12 h-12 rounded-2xl overflow-hidden border border-white/10 bg-slate-800">
                  <img
                      v-if="itemModalProductImage()"
                      :src="img_source(itemModalProductImage())"
                      alt="img"
                      class="w-full h-full object-cover"
                  />
                  <div v-else class="w-full h-full flex items-center justify-center text-slate-400 text-xs">
                    ---
                  </div>
                </div>

                <div class="text-right">
                  <h3 class="text-lg font-bold text-slate-100 leading-tight">
                    {{ itemModalProductName() }}
                  </h3>
                  <p class="text-sm text-slate-400 mt-1 font-light">
                    تخفیف ردیف
                  </p>
                </div>
              </div>
            </div>

            <div class="space-y-6">
              <div class="grid grid-cols-3 gap-3 mb-6">
                <button
                    @click="itemDiscountForm.line_discount_type = ''"
                    :class="[
                'p-4 rounded-2xl border-2 transition-all duration-300 group relative overflow-hidden',
                !itemDiscountForm.line_discount_type
                  ? 'border-pink-500 bg-pink-500/10 shadow-lg shadow-pink-500/20'
                  : 'border-white/10 bg-white/5 hover:border-white/20 hover:bg-white/10'
              ]"
                >
                  <div class="text-center">
                    <div
                        class="w-8 h-8 rounded-full bg-slate-700 group-hover:bg-slate-600 mx-auto mb-2 flex items-center justify-center transition-colors">
                      <svg class="w-4 h-4 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
                      </svg>
                    </div>
                    <span class="text-xs font-medium text-slate-300 group-hover:text-white">بدون تخفیف</span>
                  </div>
                </button>

                <button
                    @click="itemDiscountForm.line_discount_type = 'percent'"
                    :class="[
                'p-4 rounded-2xl border-2 transition-all duration-300 group relative overflow-hidden',
                itemDiscountForm.line_discount_type === 'percent'
                  ? 'border-cyan-500 bg-cyan-500/10 shadow-lg shadow-cyan-500/20'
                  : 'border-white/10 bg-white/5 hover:border-white/20 hover:bg-white/10'
              ]"
                >
                  <div class="text-center">
                    <div
                        class="w-8 h-8 rounded-full bg-slate-700 group-hover:bg-slate-600 mx-auto mb-2 flex items-center justify-center transition-colors">
                      <span class="text-xs font-bold text-slate-400">%</span>
                    </div>
                    <span class="text-xs font-medium text-slate-300 group-hover:text-white">درصدی</span>
                  </div>
                </button>

                <button
                    @click="itemDiscountForm.line_discount_type = 'amount'"
                    :class="[
                'p-4 rounded-2xl border-2 transition-all duration-300 group relative overflow-hidden',
                itemDiscountForm.line_discount_type === 'amount'
                  ? 'border-purple-500 bg-purple-500/10 shadow-lg shadow-purple-500/20'
                  : 'border-white/10 bg-white/5 hover:border-white/20 hover:bg-white/10'
              ]"
                >
                  <div class="text-center">
                    <div
                        class="w-8 h-8 rounded-full bg-slate-700 group-hover:bg-slate-600 mx-auto mb-2 flex items-center justify-center transition-colors">
                      <span class="text-xs font-bold text-slate-400">تومان</span>
                    </div>
                    <span class="text-xs font-medium text-slate-300 group-hover:text-white">مبلغی</span>
                  </div>
                </button>
              </div>


              <!-- ورودی مقدار تخفیف -->
              <div v-if="itemDiscountForm.line_discount_type" class="mb-6">
                <label class="block text-xs font-medium text-slate-300 mb-2">
                </label>

                <div class="relative">
                  <input
                      type="number"
                      step="0.01"
                      v-model.number="itemDiscountForm.line_discount_value"
                      class="w-full px-4 py-4 pr-12 border border-white/10 rounded-2xl text-lg
                       bg-slate-800/50 text-white placeholder-slate-400 backdrop-blur-xl
                       focus:border-pink-400/50 focus:ring-2 focus:ring-pink-400/20
                       transition-all duration-200 font-medium"
                      :placeholder="itemDiscountForm.line_discount_type === 'percent' ? 'مثلاً ۱۰' : 'مثلاً ۵۰۰۰۰'"
                  />
                  <div class="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400 font-bold text-sm">
                    <span v-if="itemDiscountForm.line_discount_type === 'percent'">٪</span>
                    <span v-else>تومان</span>
                  </div>
                </div>

                <p class="mt-2 text-[11px] text-slate-400 leading-snug">
                </p>
              </div>
            </div>

            <!-- Actions (مثل تخفیف کلی) -->
            <div class="flex gap-3 mt-6">
              <button
                  @click="showItemDiscountModal = false"
                  class="flex-1 px-6 py-3.5 rounded-2xl bg-slate-800 text-slate-300 hover:bg-slate-700 hover:text-white
                   text-sm font-medium transition-all duration-200 border border-white/5 hover:border-white/10
                   hover:scale-[1.02] active:scale-[0.98]"
              >
                انصراف
              </button>
              <button
                  @click="applyItemDiscount"
                  class="flex-1 px-6 py-3.5 rounded-2xl bg-gradient-to-r from-pink-500 to-purple-600
                   text-white hover:from-pink-400 hover:to-purple-500 text-sm font-medium transition-all duration-200
                   hover:scale-[1.02] active:scale-[0.98] shadow-lg shadow-pink-500/30 hover:shadow-pink-500/40
                   flex items-center justify-center gap-2"
              >
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                </svg>
                اعمال تخفیف
              </button>
            </div>

          </div>
        </div>
      </div>
    </transition>

  </div>
</template>

<script>
import PosOrderDetailsModal from "@/modules/pos/PosOrderDetailsModal";

export default {
  name: 'PosDashboard',
  components: {PosOrderDetailsModal},
  data() {
    return {
      popupNameSearch: '',
      selectedSearchIndex: -1,
      lastUserFocus: null,
      confirmModal: {
        visible: false,
        loading: false,
        fromStatus: '',
        toStatus: '',
        title: '',
        subtitle: '',
        bullets: [],
        confirmText: 'تأیید'
      },
      successStatusLoading: false,
      successStatusError: '',
      showItemDiscountModal: false,
      showItemWholesaleModal: false,
      itemModalTarget: null,

      itemDiscountForm: {
        line_discount_type: '',
        line_discount_value: null,
      },

      itemWholesaleForm: {
        is_wholesale: false,
        profit_margin: null,
        base: null,
      },

      navOpen: true,
      activeTab: 'pos',
      loading: {
        global: false,
        submit: false,
        orders: false
      },
      notice: '',
      searchQuery: '',
      searchLoading: false,
      searchResults: [],
      debouncedSearchFn: null,
      cartItems: [],
      orderDiscount: {
        type: 'none',
        value: null
      },
      wholesaleGlobal: {
        enabled: false,
        margin_percent: null
      },
      customer: {
        first_name: '',
        last_name: '',
        phone_number: '',
        user_id: null
      },
      lastOrder: null,
      orderQrUrl: '',
      lastOrderLink: '',
      orderSuccess: {
        visible: false,
        order: null
      },
      orders: {
        items: [],
        total: 0,
        page: 1,
        page_size: 10,
        total_pages: 1
      },
      ordersFilters: {
        search: '',
        date_from: '',
        date_to: '',
        status: ''
      },
      orderDetails: null,
      orderDetailsLoading: false,
      orderDetailsSaving: false,
      orderDetailsEdit: {
        first_name: '',
        last_name: '',
        phone_number: '',
        order_discount_type: '',
        order_discount_value: null,
        wholesale_margin_percent: null
      },
      showOrderDetailsModal: false,
      orderDetailsSearchQuery: '',
      orderDetailsSearchLoading: false,
      orderDetailsSearchResults: [],
      overview: {
        today_total: 0,
        today_orders: 0,
        yesterday_total: 0,
        yesterday_orders: 0,
        month_total: 0,
        month_orders: 0,
        avg_basket: 0
      },
      showDiscountModal: false,
      showWholesaleModal: false,
      bulkDiscount: {
        type: 'none',
        value: null
      },
      bulkWholesale: {
        enabled: false,
        margin_percent: null
      },
      successStatusForm: {
        status: '',
        loading: false
      }
    }
  },
  computed: {
    title() {
      return this.setDocumentTitle('فروش حضوری')
    },
    filteredSearchResults() {
      const q = (this.popupNameSearch || '').trim().toLowerCase()

      if (!q) return this.searchResults

      return this.searchResults.filter(p => {
        const name = `${p.variation_of_name || ''} ${p.name || ''}`.toLowerCase()
        return name.includes(q)
      })
    },
    todayVsYesterdayCircle() {
      const today = Number(this.overview?.today_total || 0)
      const yesterday = Number(this.overview?.yesterday_total || 0)

      const total = today + yesterday
      // اگر هر دو صفر بودن، نیم‌نیم نشون بده
      const todayShare = total > 0 ? today / total : 0.5
      const todayAngle = Math.round(todayShare * 360)

      const diff = today - yesterday
      const diffPercent = yesterday > 0 ? Math.round((diff / yesterday) * 100) : null

      let trend = 'flat'
      if (diff > 0) trend = 'up'
      else if (diff < 0) trend = 'down'

      return {
        today,
        yesterday,
        total,
        todayShare,
        todayAngle,
        diff,
        diffPercent,
        trend,
      }
    },
    confirmTheme() {
      const to = this.confirmModal.toStatus

      if (to === 'cf') {
        return {
          headerBg: 'bg-emerald-500/5',
          iconBox: 'bg-emerald-500/10 border-emerald-400/30',
          icon: 'text-emerald-300',
          subtitle: 'text-emerald-200/80',
          dot: 'bg-emerald-300',
          confirmBtn: 'bg-gradient-to-r from-emerald-500 to-teal-500 hover:shadow-lg hover:shadow-emerald-500/20'
        }
      }

      if (to === 'ca') {
        return {
          headerBg: 'bg-rose-500/5',
          iconBox: 'bg-rose-500/10 border-rose-400/30',
          icon: 'text-rose-300',
          subtitle: 'text-rose-200/80',
          dot: 'bg-rose-300',
          confirmBtn: 'bg-rose-400 hover:bg-rose-300'
        }
      }

      // re
      return {
        headerBg: 'bg-amber-500/5',
        iconBox: 'bg-amber-500/10 border-amber-400/30',
        icon: 'text-amber-300',
        subtitle: 'text-amber-200/80',
        dot: 'bg-amber-300',
        confirmBtn: 'bg-gradient-to-r from-amber-400 to-orange-500 hover:shadow-lg hover:shadow-amber-500/20'
      }
    },
    lockedStatusMessage() {
      const s = (this.successOrder && this.successOrder.status) || ''
      if (s === 'ca') return 'سفارش لغو شده و تغییرپذیر نیست. برای ادامه، سفارش جدید ثبت کنید.'
      if (s === 're') return 'سفارش برگشت از خرید شده و تغییرپذیر نیست. برای فروش مجدد، سفارش جدید ثبت کنید.'
      return 'این سفارش قابل تغییر وضعیت نیست.'
    },
    successHeader() {
      const s = (this.successOrder && this.successOrder.status) || 'dr'

      if (s === 'dr') {
        return {
          title: 'سفارش در حالت پیش‌نویس است',
          subtitle: 'می‌تونی نهایی یا لغو کنی.',
          badgeText: 'پیش‌نویس',
          badgeClass: 'bg-amber-500/10 border-amber-400/40 text-amber-200',
          subtitleClass: 'text-amber-200/80'
        }
      }
      if (s === 'cf') {
        return {
          title: 'سفارش نهایی ثبت شد',
          subtitle: 'موجودی کالاها کسر شده و سفارش قابل ویرایش نیست.',
          badgeText: 'نهایی شده',
          badgeClass: 'bg-emerald-500/10 border-emerald-400/40 text-emerald-200',
          subtitleClass: 'text-emerald-200/80'
        }
      }
      if (s === 'ca') {
        return {
          title: 'سفارش لغو شد',
          subtitle: 'این سفارش قابل تغییر وضعیت نیست. برای ادامه، سفارش جدید ثبت کنید.',
          badgeText: 'لغو شده',
          badgeClass: 'bg-rose-500/10 border-rose-400/40 text-rose-200',
          subtitleClass: 'text-rose-200/80'
        }
      }
      // re
      return {
        title: 'برگشت از خرید سفارش انجام شد',
        subtitle: 'این سفارش قابل تغییر وضعیت نیست. برای فروش مجدد، سفارش جدید ثبت کنید.',
        badgeText: 'برگشت از خرید',
        badgeClass: 'bg-indigo-500/10 border-indigo-400/40 text-indigo-200',
        subtitleClass: 'text-indigo-200/80'
      }
    },
    successOrder() {
      return (this.orderSuccess && this.orderSuccess.order) ? this.orderSuccess.order : {}
    },
    successCustomerName() {
      const o = this.successOrder || {}
      const n = `${o.first_name || ''} ${o.last_name || ''}`.trim()
      return n || o.customer_display_name || ''
    },
    successCustomerPhone() {
      const o = this.successOrder || {}
      return o.phone_number || o.customer_username || ''
    },
    successStatusPillClass() {
      const s = (this.successOrder && this.successOrder.status) || ''
      if (s === 'cf') return 'bg-emerald-500/10 border-emerald-400/40 text-emerald-200'
      if (s === 'ca') return 'bg-rose-500/10 border-rose-400/40 text-rose-200'
      if (s === 're') return 'bg-amber-500/10 border-amber-400/40 text-amber-200'
      return 'bg-slate-800/60 border-slate-500/50 text-slate-200'
    },
    successPrintLabel() {
      const s = (this.successOrder && this.successOrder.status) || ''
      if (s === 'cf') return 'چاپ فاکتور'
      if (s === 'dr') return 'چاپ پیش‌فاکتور'
      return 'جزئیات فاکتور'
    },
    cartTotalQuantity() {
      return this.cartItems.reduce((sum, item) => sum + (Number(item.quantity) || 0), 0)
    },
    subtotalBeforeDiscounts() {
      return this.cartItems.reduce((sum, item) => {
        const qty = Number(item.quantity) || 0
        const price = Number(item.unit_price) || 0
        return sum + qty * price
      }, 0)
    },
    totalLineDiscountAmount() {
      return this.cartItems.reduce((sum, item) => sum + (item.line_discount_amount || 0), 0)
    },
    subtotalAfterLineDiscounts() {
      return this.subtotalBeforeDiscounts - this.totalLineDiscountAmount
    },
    orderDiscountAmount() {
      if (!this.subtotalAfterLineDiscounts) return 0
      if (this.orderDiscount.type === 'percent' && this.orderDiscount.value) {
        return (this.subtotalAfterLineDiscounts * Number(this.orderDiscount.value || 0)) / 100
      }
      if (this.orderDiscount.type === 'amount' && this.orderDiscount.value) {
        return Math.min(Number(this.orderDiscount.value || 0), this.subtotalAfterLineDiscounts)
      }
      return 0
    },
    grandTotal() {
      const val = this.subtotalAfterLineDiscounts - this.orderDiscountAmount
      return val > 0 ? val : 0
    }
  },
  watch: {
    searchQuery(val) {
      if (!val || val.length < 2) {
        this.searchResults = []
        return
      }
      if (this.debouncedSearchFn) {
        this.debouncedSearchFn(val)
      } else {
        this.searchProducts(val)
      }
    },
    'orderSuccess.visible': {
      immediate: true,
      handler(v) {
        if (v && this.orderSuccess && this.orderSuccess.order) {
          this.successStatusForm.status = this.orderSuccess.order.status || ''
        }
      }
    }
  },
  mounted() {
    document.title = 'اکسونی | فروشگاه حضوری'
    window.addEventListener('keydown', this.handleKeyboardNavigation);
    window.addEventListener('keydown', this.handleScannerInput);
  },
  beforeDestroy() {
    //window.removeEventListener('focusin', this.storeUserFocus);
    window.removeEventListener('keydown', this.handleScannerInput);
    window.removeEventListener('keydown', this.handleKeyboardNavigation);
  },
  created() {
    this.debouncedSearchFn = this.debounce(this.searchProducts, 300)
    this.fetchOverview()
    this.fetchOrders()
  },
  methods: {
    closeSearchPopup() {
      this.searchQuery = ''
      this.popupNameSearch = ''
      this.searchResults = []
      this.selectedSearchIndex = -1

      if (this.$refs.searchInput) {
        this.$refs.searchInput.blur()
      }
    },

    clearSearch() {
      this.searchQuery = ''
      this.popupNameSearch = ''
      this.searchResults = []
      this.selectedSearchIndex = -1

      if (this.$refs.searchInput) {
        this.$refs.searchInput.blur()
      }
    },

    selectSearchProduct(product) {
      if (!product || !product.inventory_count || Number(product.inventory_count) <= 0) return

      this.addProductToCart(product)

      this.searchQuery = ''
      this.popupNameSearch = ''
      this.searchResults = []
      this.selectedSearchIndex = -1

      if (this.$refs.searchInput) {
        this.$refs.searchInput.blur()
      }
    },
    scrollToSelectedItem() {
      this.$nextTick(() => {
        const items = document.querySelectorAll('.search-result-item');
        if (items[this.selectedSearchIndex]) {
          items[this.selectedSearchIndex].scrollIntoView({
            behavior: 'smooth',
            block: 'nearest'
          });
        }
      });
    },
    handleKeyboardNavigation(e) {
      const activeEl = document.activeElement
      const isPopupNameSearch =
          activeEl && activeEl === this.$refs.popupNameSearchInput

      if (isPopupNameSearch) {
        if (e.key === 'Escape') {
          e.preventDefault()
          this.closeSearchPopup()
        }
        return
      }
      if (this.confirmModal.visible) {
        if (e.key === 'Enter') {
          e.preventDefault();
          this.confirmStatusChange();
          return;
        }
      }

      if (this.orderSuccess.visible) {
        if (e.key === 'Enter') {
          e.preventDefault();
          const order = this.successOrder;
          if (order.status === 'cf') {
            this.printFromSuccess();
          }
          else if (order.status === 'dr') {
            this.applySuccessStatus('cf');
            setTimeout(() => {
              if (this.successOrder.status === 'cf') {
                this.printFromSuccess();
              }
            }, 500);
          }
          else {
            this.closeOrderSuccessModal();
          }
          return;
        }

        if (e.key === 'Escape') {
          e.preventDefault();
          this.closeOrderSuccessModal();
          return;
        }
      }

      if (this.searchQuery && this.searchResults.length) {
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          this.selectedSearchIndex = Math.min(
              this.selectedSearchIndex + 1,
              this.searchResults.length - 1
          );
          this.scrollToSelectedItem();
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          this.selectedSearchIndex = Math.max(this.selectedSearchIndex - 1, -1);
          this.scrollToSelectedItem();
        } else if (e.key === 'Enter' && this.selectedSearchIndex >= 0) {
          e.preventDefault();
          const selectedProduct = this.searchResults[this.selectedSearchIndex];
          if (selectedProduct && selectedProduct.inventory_count > 0) {
            this.addProductToCart(selectedProduct);
            this.clearSearch();
            this.selectedSearchIndex = -1;
          }
        }
      } else if (this.activeTab === 'pos' && e.key === 'Enter' && !this.searchQuery) {
        e.preventDefault();
        if (this.cartItems.length) {
          this.submitOrder();
        }
      }
    },

    getStatusText(status) {
      const texts = {
        'dr': 'پیش‌نویس',
        'cf': 'نهایی',
        're': 'برگشت از فروش شده',
        'ca': 'لغو شده'
      };
      return texts[status] || 'نامشخص';
    },
    getStatusColor(status) {
      const colors = {
        'dr': 'text-amber-400',
        'cf': 'text-green-400',
        're': 'text-purple-400',
        'ca': 'text-rose-400'
      };
      return colors[status] || 'text-slate-400';
    },

    storeUserFocus(e) {
      const tag = e.target.tagName;
      if (['INPUT', 'TEXTAREA'].includes(tag)) {
        this.lastUserFocus = e.target;
      } else {
        this.lastUserFocus = null;
      }
    },

    handleScannerInput(e) {
      // فقط وقتی تو تب POS هستیم
      if (this.activeTab !== 'pos') return;

      const active = document.activeElement;
      const tag = active && active.tagName;
      const isInput = tag === 'INPUT' || tag === 'TEXTAREA';

      // ۱) اگر کاربر الان داره تو یه input دیگه (غیر از search) تایپ می‌کنه → مزاحم نشو
      if (isInput && active !== this.$refs.searchInput) {
        return;
      }

      // ۲) اگر هیچ inputی فوکوس نیست یا روی چیزی غیر از input هستیم → فوکوس رو بده به searchInput
      if (this.$refs.searchInput && active !== this.$refs.searchInput) {
        this.$refs.searchInput.focus();
      }

      // ۳) کاراکترها رو بریز تو searchQuery
      if (e.key.length === 1) {
        e.preventDefault();
        this.searchQuery += e.key;
      }

      // ۴) Enter = اجرا کردن سرچ و لاجیک تک‌نتیجه‌ای
      if (e.key === 'Enter') {
        e.preventDefault();
        this.onSearchEnter();  // همون نسخه async که قبلاً برات نوشتم
      }
    },

    async onSearchEnter() {
      const q = (this.searchQuery || '').trim();
      if (!q) return;

      await this.searchProducts(q); // این همون متدی‌ه که الان داری

      if (this.searchResults.length === 1) {
        const p = this.searchResults[0];
        if (p && (p.inventory_count === undefined || Number(p.inventory_count) > 0)) {
          this.addProductToCart(p);
          this.clearSearch();
        }
      }
    },
    updateWholesaleMargin(val, item) {
      item.profit_margin = val
      item.unit_price = this.calcWholesalePrice(item)
    },
    calcWholesalePrice(item) {
      const base = Number(item.base || 0)
      const margin = Number(item.profit_margin || 0)
      return base + (base * margin / 100)
    },
    openSuccessModal(order) {
      this.orderSuccess = {
        visible: true,
        order: order
      }
      if (order.status)
        this.successStatusForm.status = order.status
    },
    statusBadgeClass(s) {
      if (s === 'cf')
        return 'bg-emerald-500/10 border-emerald-400/40 text-emerald-300'
      if (s === 'dr')
        return 'bg-amber-500/10 border-amber-400/40 text-amber-200'
      if (s === 'ca')
        return 'bg-rose-500/10 border-rose-400/40 text-rose-300'
      if (s === 're')
        return 'bg-indigo-500/10 border-indigo-400/40 text-indigo-300'

      return 'bg-slate-700/20 border-white/10 text-slate-300'
    },
    applySuccessStatus(targetStatus) {
      const o = this.successOrder
      if (!o || !o.id) return

      const s = o.status
      const allowed =
          (s === 'dr' && (targetStatus === 'cf' || targetStatus === 'ca')) ||
          (s === 'cf' && targetStatus === 're')

      if (!allowed) {
        this.successStatusError = 'این تغییر وضعیت مجاز نیست.'
        return
      }

      const cfg = this.buildConfirmConfig(s, targetStatus)

      this.confirmModal = {
        visible: true,
        loading: false,
        fromStatus: s,
        toStatus: targetStatus,
        title: cfg.title,
        subtitle: cfg.subtitle,
        bullets: cfg.bullets,
        confirmText: cfg.confirmText
      }
    },

    buildConfirmConfig(fromStatus, toStatus) {
      if (fromStatus === 'dr' && toStatus === 'cf') {
        return {
          title: 'نهایی کردن سفارش',
          subtitle: 'این عملیات برگشت‌پذیر نیست مگر با برگشت از خرید.',
          bullets: [
            'موجودی کالاها از انبار کسر می‌شود.',
            'سفارش دیگر قابل ویرایش نیست.',
            'فاکتور نهایی قابل چاپ می‌شود.'
          ],
          confirmText: 'نهایی کن'
        }
      }

      if (fromStatus === 'dr' && toStatus === 'ca') {
        return {
          title: 'لغو سفارش',
          subtitle: 'بعد از لغو، سفارش قابل تغییر وضعیت نخواهد بود.',
          bullets: [
            'سفارش بسته می‌شود و دیگر تغییرپذیر نیست.',
            'موجودی تغییر نمی‌کند (چون سفارش هنوز نهایی نشده).'
          ],
          confirmText: 'لغو کن'
        }
      }

      // cf -> re
      return {
        title: 'ثبت برگشت از خرید',
        subtitle: 'برگشت از خرید یعنی بازگشت کالا و اصلاح موجودی.',
        bullets: [
          'موجودی کالاها به انبار برمی‌گردد.',
          'سفارش دیگر قابل تغییر وضعیت نیست.',
          'جزئیات فاکتور برای پیگیری باقی می‌ماند.'
        ],
        confirmText: 'برگشت از خرید ثبت کن'
      }
    },

    closeConfirmModal() {
      if (this.confirmModal.loading) return
      this.confirmModal.visible = false
    },

    async confirmStatusChange() {
      const o = this.successOrder
      if (!o || !o.id) return

      const targetStatus = this.confirmModal.toStatus
      if (!targetStatus) return

      this.confirmModal.loading = true
      this.successStatusError = ''

      try {
        const updated = await this.apiPostPos(`orders/${o.id}/set-status/`, {status: targetStatus})
        this.orderSuccess.order = updated
        this.toast('وضعیت سفارش اعمال شد')
        this.confirmModal.visible = false

        if (this.refreshOrders) await this.refreshOrders()
      } catch (e) {
        console.error('confirmStatusChange error:', e)
        this.successStatusError = 'خطا در تغییر وضعیت سفارش'
        this.toast('خطا در تغییر وضعیت سفارش')
      } finally {
        this.confirmModal.loading = false
        this.fetchOrders()
        this.fetchOverview()
      }
    },
    statusConfirmMessage(fromStatus, toStatus) {
      // از dr
      if (fromStatus === 'dr' && toStatus === 'cf') {
        return 'با نهایی کردن سفارش:\n• برگشت از خرید کالاها کسر می‌شود\n• سفارش دیگر قابل ویرایش نیست\n\nادامه می‌دهید؟'
      }
      if (fromStatus === 'dr' && toStatus === 'ca') {
        return 'با لغو سفارش:\n• سفارش بسته می‌شود\n• دیگر قابل تغییر وضعیت نیست\n\nلغو شود؟'
      }
      // از cf
      if (fromStatus === 'cf' && toStatus === 're') {
        return 'با برگشت از خرید سفارش:\n• موجودی کالاها به انبار برمی‌گردد\n• سفارش دیگر قابل تغییر وضعیت نیست\n\nبرگشت از خرید ثبت شود؟'
      }
      return 'آیا مطمئن هستید؟'
    },
    printFromSuccess() {
      const o = this.successOrder
      if (!o || !o.id) {
        this.toast('سفارشی برای چاپ پیدا نشد')
        return
      }

      const url = this.endpoint(`pos/v1/print/${o.id}/html/?token=${this.token}`)

      window.open(url, '_blank')
    },
    itemWholesalePreviewPrice() {
      const item = this.itemModalTarget
      if (!item) return 0

      const base = Number(item.base || 0)
      const margin = Number(item.profit_margin || 0)

      if (!base || !margin) return 0

      return base * (1 + margin / 100)
    },

    openItemDiscountModal(item) {
      this.itemModalTarget = item
      this.itemDiscountForm = {
        line_discount_type: item.line_discount_type || '',
        line_discount_value: item.line_discount_value ?? null,
      }
      this.showItemDiscountModal = true
    },

    applyItemDiscount() {
      const item = this.itemModalTarget
      if (!item) return

      const t = this.itemDiscountForm.line_discount_type || ''
      const v = this.itemDiscountForm.line_discount_value

      if (!t) {
        item.line_discount_type = ''
        item.line_discount_value = null
        item.line_discount_amount = 0
      } else {
        item.line_discount_type = t
        item.line_discount_value =
            (v === '' || v === null || v === undefined) ? null : Number(v)
      }

      this.recalculateLine(item)

      if (this.orderDiscount.type !== 'none' || this.orderDiscount.value) {
        this.orderDiscount.type = 'none'
        this.orderDiscount.value = null
      }

      this.showItemDiscountModal = false
      this.itemModalTarget = null
    },
    openItemWholesaleModal(item) {
      this.itemModalTarget = item
      this.itemWholesaleForm = {
        is_wholesale: !!item.is_wholesale,
        profit_margin: item.profit_margin ?? null,
        base: item.base ?? null,
      }
      this.showItemWholesaleModal = true
    },

    applyItemWholesale() {
      const item = this.itemModalTarget
      if (!item) return

      item.is_wholesale = !!this.itemWholesaleForm.is_wholesale

      if (item.is_wholesale) {
        const pm = this.itemWholesaleForm.profit_margin
        item.profit_margin =
            (pm === '' || pm === null || pm === undefined) ? null : Number(pm)

        this.applyWholesalePricing(item)   // همون متد خودت
      } else {
        item.unit_price = Number(item.product.pos_price || item.product.price || item.unit_price)
        item.profit_margin = null
      }

      this.recalculateLine(item)

      // ✅ هر تغییری روی عمده‌ی آیتم → عمده‌ی کلی خاموش بشه
      this.wholesaleGlobal.enabled = false
      this.wholesaleGlobal.margin_percent = null

      this.showItemWholesaleModal = false
      this.itemModalTarget = null
    },

    itemModalProductName() {
      const it = this.itemModalTarget
      return it && it.product ? (it.product.name || 'محصول') : 'محصول'
    },

    itemModalProductImage() {
      const it = this.itemModalTarget
      return it && it.product ? (it.product.image || null) : null
    },


    openItemPopup(item, tab) {
      this.itemPopupTarget = item
      this.itemPopupTab = tab || 'discount'

      this.itemPopupForm = {
        line_discount_type: item.line_discount_type || '',
        line_discount_value: item.line_discount_value ?? null,

        is_wholesale: !!item.is_wholesale,
        profit_margin: item.profit_margin ?? null,
      }

      this.itemPopupOpen = true
    },

    closeItemPopup() {
      this.itemPopupOpen = false
      this.itemPopupTarget = null
    },

    // فقط UI رو آپدیت می‌کنه و همون recalculateLine خودت رو صدا می‌زنه
    applyItemPopup() {
      const item = this.itemPopupTarget
      if (!item) return

      // discount
      const t = this.itemPopupForm.line_discount_type || ''
      const v = this.itemPopupForm.line_discount_value

      if (!t) {
        item.line_discount_type = ''
        item.line_discount_value = null
      } else {
        item.line_discount_type = t
        item.line_discount_value =
            (v === '' || v === null || v === undefined) ? null : Number(v)
      }

      // wholesale
      item.is_wholesale = !!this.itemPopupForm.is_wholesale
      if (item.is_wholesale) {
        const pm = this.itemPopupForm.profit_margin
        item.profit_margin =
            (pm === '' || pm === null || pm === undefined) ? null : Number(pm)
      } else {
        item.profit_margin = null
      }

      // این همون محاسبه‌ایه که خودت داری
      // (فرض: recalculateLine(item) تو کدت هست و line_discount_amount/line_total رو آپدیت می‌کنه)
      this.recalculateLine(item)

      this.closeItemPopup()
    },

    // فقط برای نمایش روی ردیف
    itemDiscountLabel(item) {
      if (!item.line_discount_type || item.line_discount_value === null || item.line_discount_value === undefined || item.line_discount_value === '') {
        return 'بدون تخفیف'
      }
      if (item.line_discount_type === 'percent') return `٪${Number(item.line_discount_value)}`
      return 'مبلغی'
    },

    itemWholesaleLabel(item) {
      if (!item.is_wholesale) return 'خرده'
      if (item.profit_margin !== null && item.profit_margin !== undefined && item.profit_margin !== '') {
        return `عمده ٪${Number(item.profit_margin)}`
      }
      return 'عمده'
    },
    calcLineDiscountAmount(item) {
      const qty = Number(item.quantity || 0)
      const unitPrice = Number(item.unit_price || 0)  // ✔ قیمت فعلی (خرده یا عمده)

      const subtotal = unitPrice * qty

      const t = item.line_discount_type
      const v = item.line_discount_value

      if (!t || v === null || v === undefined || v === '') return 0

      let discount = 0
      const value = Number(v || 0)

      if (t === 'percent') {
        discount = (subtotal * value) / 100
      } else {
        discount = value
      }

      if (discount < 0) discount = 0
      if (discount > subtotal) discount = subtotal
      return discount
    },

    calcLineSubtotal(item) {
      const qty = Number(item.quantity || 0)
      const unitPrice = Number(item.unit_price || 0)  // ✔
      return unitPrice * qty
    },

    isWholesaleItem(item) {
      // هر چی تو سبد داری: یا is_wholesale داری یا profit_margin/wholesale_margin_percent
      return !!item.is_wholesale || item.wholesale_margin_percent != null || (item.profit_margin != null && Number(item.profit_margin) > 0)
    },
    toggleLineDiscount(item) {
      if (item.line_discount_type) {
        item.line_discount_type = '';
        item.line_discount_value = 0;
        item.line_discount_amount = 0;
      } else {
        item.line_discount_type = 'percent';
        item.line_discount_value = 10;
      }
      this.onLineDiscountChange(item);
    },

    posStatusLabel(status) {
      const map = {
        dr: 'پیش‌نویس',
        cf: 'نهایی شده',
        ca: 'لغو شده',
        re: 'برگشت از خرید'
      }
      return map[status] || status
    },

    openOrderDetails(order) {
      const id = typeof order === 'object' ? order.id : order
      if (!id) return

      if (this.$refs.orderDetailsModal && this.$refs.orderDetailsModal.openOrderDetails) {
        this.$refs.orderDetailsModal.openOrderDetails(id)
      }
    },
    async fetchOrderDetails(id) {
      const data = await this.apiGetPos(`orders/${id}/`, {})
      this.orderDetails = data

      this.orderDetailsEdit = {
        first_name: data.first_name || '',
        last_name: data.last_name || '',
        phone_number: data.phone_number || '',
        order_discount_type: data.order_discount_type || '',
        order_discount_value: data.order_discount_value,
        wholesale_margin_percent: data.wholesale_margin_percent
      }

      const map = {}
      ;(data.items || []).forEach(it => {
        map[it.id] = {
          quantity: it.quantity,
          line_discount_type: it.line_discount_type || '',
          line_discount_value: it.line_discount_value,
          wholesale_margin_percent: it.wholesale_margin_percent
        }
      })
      this.orderDetailsItemsEdit = map
    },

    clearOrderDetails() {
      this.orderDetails = null
      this.orderDetailsItemsEdit = {}
      this.orderDetailsSearchQuery = ''
      this.orderDetailsSearchResults = []
    },
    closeOrderDetailsModal() {
      this.showOrderDetailsModal = false
      this.clearOrderDetails()
    },
    async saveOrderDetails() {
      if (!this.orderDetails) return

      this.orderDetailsSaving = true
      try {
        const id = this.orderDetails.id
        await this.apiPatchPos(`orders/${id}/`, {
          first_name: this.orderDetailsEdit.first_name || null,
          last_name: this.orderDetailsEdit.last_name || null,
          phone_number: this.orderDetailsEdit.phone_number || null,
          order_discount_type: this.orderDetailsEdit.order_discount_type || null,
          order_discount_value: this.orderDetailsEdit.order_discount_value,
          wholesale_margin_percent: this.orderDetailsEdit.wholesale_margin_percent
        })

        this.toast('سفارش بروزرسانی شد')
        await this.fetchOrderDetails(id)
        await this.fetchOrders()
      } catch (e) {
        console.error('Error saving order details:', e)
        this.toast('خطا در بروزرسانی سفارش')
      } finally {
        this.orderDetailsSaving = false
      }
    },

    async saveOrderItem(itemId) {
      if (!this.orderDetails || !this.orderDetailsItemsEdit[itemId]) return

      const payload = this.orderDetailsItemsEdit[itemId]

      try {
        await this.apiPatchPos(`order-items/${itemId}/`, {
          quantity: payload.quantity,
          line_discount_type: payload.line_discount_type || null,
          line_discount_value: payload.line_discount_value,
          wholesale_margin_percent: payload.wholesale_margin_percent
        })

        this.toast('ردیف بروزرسانی شد')
        await this.fetchOrderDetails(this.orderDetails.id)
        await this.fetchOrders()
      } catch (e) {
        console.error('Error updating order item:', e)
        this.toast('خطا در بروزرسانی ردیف')
      }
    },

    async removeOrderItem(itemId) {
      if (!this.orderDetails) return

      try {
        await this.apiDeletePos(`order-items/${itemId}/`)
        this.toast('ردیف حذف شد')
        await this.fetchOrderDetails(this.orderDetails.id)
        await this.fetchOrders()
      } catch (e) {
        console.error('Error deleting order item:', e)
        this.toast('خطا در حذف ردیف')
      }
    },

    async searchProductsForOrderDetails() {
      const q = (this.orderDetailsSearchQuery || '').trim()
      if (q.length < 2) {
        this.orderDetailsSearchResults = []
        return
      }

      this.orderDetailsSearchLoading = true
      try {
        const data = await this.apiGetPos('products/search/', {suffix: q})
        this.orderDetailsSearchResults = data.results || data || []
      } catch (e) {
        console.error('Error searching products for order details:', e)
        this.toast('خطا در جستجوی کالا')
      } finally {
        this.orderDetailsSearchLoading = false
      }
    },

    async addProductToOrderFromDetails(product) {
      if (!this.orderDetails || !product) return

      try {
        await this.apiPostPos('order-items/', {
          order: this.orderDetails.id,
          product: product.id,
          quantity: 1
        })

        this.toast('کالا به سفارش اضافه شد')
        this.orderDetailsSearchQuery = ''
        this.orderDetailsSearchResults = []

        await this.fetchOrderDetails(this.orderDetails.id)
        await this.fetchOrders()
      } catch (e) {
        console.error('Error adding product to order from details:', e)
        this.toast('خطا در افزودن کالا به سفارش')
      }
    },
    calculateLineTotal(item) {
      const baseAmount = item.quantity * item.unit_price;
      item.line_total = baseAmount - (item.line_discount_amount || 0);
    },
    logout() {
      this.setToken("");
      this.$store.commit("setUser", null);
      if (this.$route.name != "Login") {
        let url = this.$router.resolve({name: "Login"});
        window.location = url;
      }
      this.tabEmit("logout");
    },

    setTab(key) {
      this.activeTab = key
    },
    debounce(fn, delay) {
      let timeout
      return (...args) => {
        clearTimeout(timeout)
        timeout = setTimeout(() => fn.apply(this, args), delay)
      }
    },
    toast(msg) {
      this.notice = msg
      setTimeout(() => {
        this.notice = ''
      }, 3000)
    },
    formatCurrency(amount) {
      if (!amount) return '۰'
      return new Intl.NumberFormat('fa-IR').format(Number(amount)) + ' تومان'
    },
    cleanParams(obj) {
      const copy = {...(obj || {})}
      Object.keys(copy).forEach(k => {
        if (copy[k] === '' || copy[k] === null || copy[k] === undefined) delete copy[k]
      })
      return copy
    },
    apiGetPos(path, params) {
      return new Promise((resolve, reject) => {
        this.request({
          url: this.endpoint(`pos/v1/${path}`),
          method: 'get',
          params: this.cleanParams(params || {}),
          success: data => resolve(data),
          error: err => reject(err)
        })
      })
    },
    apiPostPos(path, data) {
      const payload = this.cleanParams(data || {})
      return new Promise((resolve, reject) => {
        this.request({
          url: this.endpoint(`pos/v1/${path}`),
          method: 'post',
          data: payload,
          success: data => resolve(data),
          error: err => reject(err)
        })
      })
    },
    lineDiscountPercent(item) {
      const reg = Number(item.regular_price || 0)
      const price = Number(item.unit_price || 0)
      if (!reg || !price || price >= reg) return 0
      const diff = reg - price
      return Math.round((diff * 100) / reg)
    },
    async searchProducts(query) {
      this.searchLoading = true
      this.selectedSearchIndex = -1
      try {
        const params = {
          suffix: (query || '').trim()
        }
        const data = await this.apiGetPos('products/search/', params)
        this.searchResults = data.results || data || []
      } catch (e) {
        console.error('Error searching products:', e)
        this.toast('خطا در جستجوی کالا')
      } finally {
        this.searchLoading = false
      }
    },
    addProductToCart(product) {
      const stock = (product && product.inventory_count != null)
          ? Number(product.inventory_count)
          : null

      // اگه موجودی صفر یا منفی بود اصلاً اضافه نکن
      if (stock !== null && stock <= 0) {
        this.toast('این کالا در حال حاضر ناموجود است')
        return
      }

      const existing = this.cartItems.find(
          item => item.product && item.product.id === product.id && !item.is_wholesale
      )

      if (existing) {
        // اگر موجودی تعریف شده، بیشتر از اون نرو
        if (stock && existing.quantity >= stock) {
          this.toast('بیشتر از موجودی انبار نمی‌توان اضافه کرد')
        } else {
          const nextQty = stock ? Math.min(existing.quantity + 1, stock) : (existing.quantity + 1)
          existing.quantity = nextQty
          this.recalculateLine(existing)
        }
      } else {
        const base = Number(product.base || product.price || 0)
        const regularPrice = Number(product.regular_price || product.price || 0)
        const price = Number(product.pos_price || product.price || 0)
        const currencyRate = Number(product.current_currency_rate || 1)
        const profitType = product.profit_type || 'percent'
        const profitMargin = Number(product.profit_margin || 0)

        const item = {
          _key: `${product.id}-${Date.now()}-${Math.random()}`,
          product,
          quantity: 1,
          base: base,
          regular_price: regularPrice,
          unit_price: price,
          current_currency_rate: currencyRate,
          profit_type: profitType,
          profit_margin: profitMargin,
          is_wholesale: false,
          line_discount_type: '',
          line_discount_value: null,
          line_discount_amount: 0,
          line_total: price
        }
        this.recalculateLine(item)
        this.cartItems.unshift(item)
      }

      this.clearSearch()
    },
    clearCart() {
      this.cartItems = []
    },
    removeItem(idx) {
      this.cartItems.splice(idx, 1)
    },
    changeQuantity(idx, newQty) {
      const item = this.cartItems[idx]
      if (!item) return

      const stock = (item.product && item.product.inventory_count != null)
          ? Number(item.product.inventory_count)
          : null

      // 👇 اگر صفر یا خالی شد، ردیف رو حذف کن
      if (!newQty || newQty <= 0) {
        this.removeItem(idx)
        return
      }

      // اگر موجودی تعریف شده، سقف بذار
      if (stock && newQty > stock) newQty = stock

      item.quantity = newQty
      this.recalculateLine(item)
    },

    onQuantityInput(idx) {
      const item = this.cartItems[idx]
      if (!item) return

      let q = Number(item.quantity) || 0
      const stock = (item.product && item.product.inventory_count != null)
          ? Number(item.product.inventory_count)
          : null

      if (q <= 0) {
        this.removeItem(idx)
        return
      }

      if (stock && q > stock) q = stock

      item.quantity = q
      this.recalculateLine(item)
    },
    toggleWholesale(idx) {
      const item = this.cartItems[idx]
      item.is_wholesale = !item.is_wholesale
      if (item.is_wholesale) {
        if (this.wholesaleGlobal.enabled && this.wholesaleGlobal.margin_percent) {
          item.profit_margin = this.wholesaleGlobal.margin_percent
        }
        this.applyWholesalePricing(item)
      } else {
        item.unit_price = Number(item.product.pos_price || item.product.price || item.unit_price)
      }
      this.recalculateLine(item)
    },
    onWholesaleMarginChange(item) {
      this.applyWholesalePricing(item)
      this.recalculateLine(item)
    },
    recalculateLine(item) {
      const qty = Number(item.quantity) || 0
      const unit = Number(item.unit_price) || 0
      const beforeDiscount = qty * unit

      let lineDiscount = 0
      if (item.line_discount_type === 'percent' && item.line_discount_value) {
        lineDiscount = (beforeDiscount * Number(item.line_discount_value || 0)) / 100
      } else if (item.line_discount_type === 'amount' && item.line_discount_value) {
        lineDiscount = Math.min(Number(item.line_discount_value || 0), beforeDiscount)
      }

      item.line_discount_amount = lineDiscount
      item.line_total = beforeDiscount - lineDiscount
    },
    onLineDiscountChange(item) {
      this.recalculateLine(item)
    },
    applyWholesalePricing(item) {
      const base = Number(item.base || 0)
      const margin = Number(item.profit_margin || 0)
      if (!base || !margin) return
      const price = base * (1 + margin / 100)
      item.unit_price = price
    },
    applyWholesaleToAll() {
      if (!this.wholesaleGlobal.margin_percent) return
      this.cartItems.forEach(item => {
        item.is_wholesale = true
        item.profit_margin = this.wholesaleGlobal.margin_percent
        this.applyWholesalePricing(item)
        this.recalculateLine(item)
      })
      this.toast('سود عمده روی همه ردیف‌ها اعمال شد')
    },
    openDiscountModal() {
      this.bulkDiscount.type = this.orderDiscount.type
      this.bulkDiscount.value = this.orderDiscount.value
      this.showDiscountModal = true
    },
    applyBulkDiscount() {
      const type = this.bulkDiscount.type
      const rawValue = this.bulkDiscount.value

      // ست کردن تخفیف کلی فاکتور
      this.orderDiscount.type = type
      this.orderDiscount.value =
          type === 'none'
              ? null
              : (rawValue === '' || rawValue === null || rawValue === undefined
                  ? null
                  : Number(rawValue))

      // ✅ علاوه بر کلی، روی تک‌تک ردیف‌ها هم اعمال کن
      if (this.orderDiscount.type !== 'none' && this.orderDiscount.value != null) {
        this.cartItems.forEach(item => {
          item.line_discount_type = this.orderDiscount.type
          item.line_discount_value = this.orderDiscount.value
          this.recalculateLine(item)
        })
      }

      this.showDiscountModal = false
    },
    openWholesaleModal() {
      this.bulkWholesale.enabled = this.wholesaleGlobal.enabled
      this.bulkWholesale.margin_percent = this.wholesaleGlobal.margin_percent
      this.showWholesaleModal = true
    },
    applyBulkWholesale() {
      this.wholesaleGlobal.enabled = this.bulkWholesale.enabled
      this.wholesaleGlobal.margin_percent = this.bulkWholesale.enabled ? this.bulkWholesale.margin_percent : null

      if (this.wholesaleGlobal.enabled && this.wholesaleGlobal.margin_percent) {
        this.cartItems.forEach(item => {
          item.is_wholesale = true
          item.profit_margin = this.wholesaleGlobal.margin_percent
          this.applyWholesalePricing(item)
          this.recalculateLine(item)
        })
        this.toast('سود عمده روی همه ردیف‌ها اعمال شد')
      }

      this.showWholesaleModal = false
    },
    buildOrderPayload() {
      const items = this.cartItems.map(item => ({
        product: item.product.id,
        quantity: item.quantity,
        base: item.base,
        current_currency_rate: item.current_currency_rate,
        profit_type: item.profit_type,
        profit_margin: item.profit_margin,
        price: item.unit_price,
        regular_price: item.regular_price,
        line_discount_type: item.line_discount_type || null,
        line_discount_value: item.line_discount_value || null,
        is_wholesale: item.is_wholesale
      }))

      return {
        customer_first_name: this.customer.first_name || null,
        customer_last_name: this.customer.last_name || null,
        customer_phone_number: this.customer.phone_number || null,
        customer_user_id: this.customer.user_id || null,

        discount_type: this.orderDiscount.type,
        discount_value: this.orderDiscount.value || null,

        items,
        client_subtotal: this.subtotalBeforeDiscounts,
        client_line_discount_total: this.totalLineDiscountAmount,
        client_order_discount_total: this.orderDiscountAmount,
        client_final_amount: this.grandTotal
      }
    },
    async submitOrder() {
      if (!this.cartItems.length) {
        this.toast('سبد خالی است')
        return
      }
      this.loading.submit = true
      try {
        const payload = this.buildOrderPayload()
        const order = await this.apiPostPos('orders/', payload)
        this.lastOrder = order
        this.generateOrderQr(order)
        this.toast('سفارش با موفقیت ثبت شد')
        this.customer = {
          first_name: '',
          last_name: '',
          phone_number: '',
          user_id: null
        }


        this.orderSuccess.order = order
        this.orderSuccess.visible = true

        this.fetchOverview()
        this.fetchOrders()
        this.clearCart()
      } catch (e) {
        console.error('Error creating POS order:', e)
        this.toast('خطا در ثبت سفارش')
      } finally {
        this.loading.submit = false
      }
    },
    generateOrderQr(order) {
      const id = order.id
      const url = this.endpoint(`pos/v1/print/${id}/html/?token=${this.token}`)
      this.lastOrderLink = url
      this.orderQrUrl = ''
    },
    copyOrderLink(o) {
      const url = this.lastOrderLink || this.endpoint(`pos/v1/print/${o.id}/html/?token=${this.token}`)
      navigator.clipboard.writeText(url).then(() => {
        this.toast('لینک فاکتور کپی شد')
      }).catch(() => {
        this.toast('خطا در کپی لینک')
      })
    },
    closeOrderSuccessModal() {
      this.orderSuccess.visible = false
    },
    goToOrdersFromModal() {
      this.activeTab = 'orders'
      this.orderSuccess.visible = false
    },
    apiPatchPos(path, data) {
      const payload = this.cleanParams(data || {})
      return new Promise((resolve, reject) => {
        this.request({
          url: this.endpoint(`pos/v1/${path}`),
          method: 'patch',
          data: payload,
          success: data => resolve(data),
          error: err => reject(err)
        })
      })
    },
    apiDeletePos(path) {
      return new Promise((resolve, reject) => {
        this.request({
          url: this.endpoint(`pos/v1/${path}`),
          method: 'delete',
          success: data => resolve(data),
          error: err => reject(err)
        })
      })
    },

    async fetchOrders() {
      this.loading.orders = true
      try {
        const params = {
          page: this.orders.page,
          page_size: this.orders.page_size,
          search: this.ordersFilters.search || undefined,
          date_from: this.ordersFilters.date_from || undefined,
          date_to: this.ordersFilters.date_to || undefined,
          status: this.ordersFilters.status || undefined,
          // اگر خواستی مرتب‌سازی هم داشته باشی:
          // ordering: '-created_at',
        }
        const data = await this.apiGetPos('orders/', params)
        const results = data.results || data || []
        this.orders.items = results
        this.orders.total = data.count || results.length
        this.orders.total_pages = Math.max(
            1,
            Math.ceil(this.orders.total / this.orders.page_size)
        )
      } catch (e) {
        console.error('Error fetching POS orders:', e)
      } finally {
        this.loading.orders = false
      }
    },
    applyOrdersFilters() {
      this.orders.page = 1
      this.fetchOrders()
    },
    clearOrdersFilters() {
      this.ordersFilters = {search: '', date_from: '', date_to: '', status: ''}
      this.applyOrdersFilters()
    },
    goOrdersPage(page) {
      this.orders.page = Math.max(1, Math.min(this.orders.total_pages, page))
      this.fetchOrders()
    },
    viewOrder(order) {
      this.lastOrder = order
      this.generateOrderQr(order)
      this.activeTab = 'pos'
      this.toast('سفارش انتخاب شد؛ لینک و QR در صفحه صدور نمایش داده شد.')
    },
    async fetchOverview() {
      try {
        const data = await this.apiGetPos('orders/summary/', {})
        this.overview = Object.assign({
          today_total: 0,
          today_orders: 0,
          yesterday_total: 0,
          yesterday_orders: 0,
          month_total: 0,
          month_orders: 0,
          avg_basket: 0
        }, data || {})
      } catch (e) {
        console.error('Error fetching POS overview:', e)
      }
    },
    refreshAll() {
      this.loading.global = true
      Promise.all([
        this.fetchOverview(),
        this.fetchOrders()
      ]).finally(() => {
        this.loading.global = false
      })
    }
  }
}
</script>

<style scoped>
.custom-scrollbar::-webkit-scrollbar {
  width: 6px;
}

.custom-scrollbar::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 3px;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}

.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.3);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>